var Painterro =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.tr = tr;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var instance = null;

var Translation = exports.Translation = function () {
  function Translation() {
    _classCallCheck(this, Translation);

    this.translations = {
      en: {
        lineColor: 'L:',
        lineColorFull: 'Line color',
        fillColor: 'F:',
        fillColorFull: 'Fill color',
        alpha: 'A:',
        alphaFull: 'Alpha',
        lineWidth: 'W:',
        lineWidthFull: 'Line width',
        textColor: 'C:',
        textColorFull: 'Text color',
        fontSize: 'S:',
        fontSizeFull: 'Font Size',
        fontName: 'F:',
        fontNameFull: 'Font name',
        apply: 'Apply',
        cancel: 'Cancel',
        close: 'Close',
        width: 'Width',
        height: 'Height',
        keepRatio: 'Keep width/height ratio',
        pixelSize: 'P:',
        pixelSizeFull: 'Pixel Size',
        resizeScale: 'Scale',
        resizeResize: 'Resize',
        tools: {
          crop: 'Crop image to selected area',
          pixelize: 'Pixelize selected area',
          rect: 'Draw rectangle',
          ellipse: 'Draw ellipse',
          line: 'Draw line',
          rotate: 'Rotate image',
          save: 'Save Image',
          load: 'Load image',
          text: 'Put text',
          brush: 'Brush',
          resize: 'Resize or scale',
          open: 'Open image',
          select: 'Select area',
          close: 'Close Painterro'
        },
        pasteOptions: {
          fit: 'Replace all',
          extend_down: 'Extend down',
          extend_right: 'Extend right',
          over: 'Paste over',
          how_to_paste: 'How to paste?'
        }
      }
    };
    this.activate('en');
    this.defaultTranslator = this.translations.en;
  }

  _createClass(Translation, [{
    key: 'addTranslation',
    value: function addTranslation(name, dict) {
      this.translations[name] = dict;
    }
  }, {
    key: 'activate',
    value: function activate(trans) {
      if (this.translations[trans] !== undefined) {
        this.trans = trans;
        this.translator = this.translations[this.trans];
      } else {
        this.translator = this.defaultTranslator;
      }
    }
  }, {
    key: 'tr',
    value: function tr(sentense) {
      var levels = sentense.split('.');
      var res = this.translator;
      var fallbackRes = this.defaultTranslator;
      levels.forEach(function (l) {
        fallbackRes = fallbackRes[l];
        if (res !== undefined) {
          res = res[l];
        }
      });
      return res || fallbackRes;
    }
  }], [{
    key: 'get',
    value: function get() {
      if (instance) {
        return instance;
      }
      instance = new Translation();
      return instance;
    }
  }]);

  return Translation;
}();

function tr(n) {
  return Translation.get().tr(n);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genId = genId;
exports.addDocumentObjectHelpers = addDocumentObjectHelpers;
exports.clearSelection = clearSelection;
exports.distance = distance;
exports.trim = trim;
exports.copyToClipboard = copyToClipboard;
function genId() {
  var text = 'ptro';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < 8; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

function addDocumentObjectHelpers() {
  if (!('documentOffsetTop' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'documentOffsetTop', {
      get: function get() {
        return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop : 0);
      }
    });
  }
  if (!('documentOffsetLeft' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'documentOffsetLeft', {
      get: function get() {
        return this.offsetLeft + (this.offsetParent ? this.offsetParent.documentOffsetLeft : 0);
      }
    });
  }

  if (!('documentClientWidth' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'documentClientWidth', {
      get: function get() {
        var rect = this.getBoundingClientRect();
        if (rect.width) {
          // `width` is available for IE9+
          return rect.width;
        }
        // Calculate width for IE8 and below
        return rect.right - rect.left;
      }
    });
  }

  if (!('documentClientHeight' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'documentClientHeight', {
      get: function get() {
        var rect = this.getBoundingClientRect();
        if (rect.height) {
          return rect.height;
        }
        return rect.bottom - rect.top;
      }
    });
  }
}

function clearSelection() {
  var selection = null;
  if (window.getSelection) {
    selection = window.getSelection();
  } else if (document.selection) {
    selection = document.selection;
  }
  if (selection) {
    if (selection.empty) {
      selection.empty();
    }
    if (selection.removeAllRanges) {
      selection.removeAllRanges();
    }
  }
}

function distance(p1, p2) {
  var a = p1.x - p2.x;
  var b = p1.y - p2.y;
  return Math.sqrt(a * a + b * b);
}

function trim(s) {
  return String(s).replace(/^\s+|\s+$/g, '');
}

var KEYS = exports.KEYS = {
  y: 89,
  z: 90,
  s: 83,
  c: 67,
  x: 88,
  enter: 13,
  esc: 27
};

// Copies a string to the clipboard. Must be called from within an
// event handler such as click. May return false if it failed, but
// this is not always possible. Browser support for Chrome 43+,
// Firefox 42+, Safari 10+, Edge and IE 10+.
// IE: The clipboard feature may be disabled by an administrator. By
// default a prompt is shown the first time the clipboard is
// used (per session).
function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    window.clipboardData.setData('Text', text);
  } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    var textarea = document.createElement('textarea');
    textarea.textContent = text;
    textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy'); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex);
    } finally {
      document.body.removeChild(textarea);
    }
  }
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(17);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);

	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.HexToRGBA = HexToRGBA;

var _translation = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HexToRGB(hex) {
  var parse = /^#?([a-fA-F\d]{2})([a-fA-F\d]{2})([a-fA-F\d]{2})$/i.exec(hex);
  if (parse) {
    return {
      r: parseInt(parse[1], 16),
      g: parseInt(parse[2], 16),
      b: parseInt(parse[3], 16)
    };
  }
  parse = /^#?([a-fA-F\d])([a-fA-F\d])([a-fA-F\d])$/i.exec(hex);
  if (parse) {
    return {
      r: parseInt(parse[1].repeat(2), 16),
      g: parseInt(parse[2].repeat(2), 16),
      b: parseInt(parse[3].repeat(2), 16)
    };
  }
}

function HexToRGBA(hex, alpha) {
  var rgb = HexToRGB(hex);
  return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + alpha + ')';
}

function format2Hex(val) {
  var hex = val.toString(16);
  return hex.length === 1 && '0' + hex || hex;
}

function rgbToHex(r, g, b) {
  return '#' + format2Hex(r) + format2Hex(g) + format2Hex(b);
}

function reversedColor(color) {
  var rgb = HexToRGB(color);
  var index = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  return index >= 128 && 'black' || 'white';
}

var ColorPicker = function () {
  function ColorPicker(main, callback) {
    var _this = this;

    _classCallCheck(this, ColorPicker);

    this.callback = callback;
    this.main = main;
    this.w = 180;
    this.h = 150;
    var w = this.w;
    var h = this.h;
    this.lightPosition = this.w - 1;

    this.wrapper = main.wrapper.querySelector('.ptro-color-widget-wrapper');
    this.input = main.wrapper.querySelector('.ptro-color-widget-wrapper .ptro-color');
    this.pipetteButton = main.wrapper.querySelector('.ptro-color-widget-wrapper button.ptro-pipette');
    this.closeButton = main.wrapper.querySelector('.ptro-color-widget-wrapper button.ptro-close-color-picker');
    this.canvas = main.wrapper.querySelector('.ptro-color-widget-wrapper canvas');
    this.ctx = this.canvas.getContext('2d');

    this.canvasLight = main.wrapper.querySelector('.ptro-color-widget-wrapper .ptro-canvas-light');
    this.colorRegulator = main.wrapper.querySelector('.ptro-color-widget-wrapper .ptro-color-light-regulator');

    this.canvasAlpha = main.wrapper.querySelector('.ptro-color-widget-wrapper .ptro-canvas-alpha');
    this.alphaRegulator = main.wrapper.querySelector('.ptro-color-widget-wrapper .ptro-color-alpha-regulator');

    this.ctxLight = this.canvasLight.getContext('2d');
    this.ctxAlpha = this.canvasAlpha.getContext('2d');
    this.canvas.setAttribute('width', '' + w);
    this.canvas.setAttribute('height', '' + h);
    this.canvasLight.setAttribute('width', '' + w);
    this.canvasLight.setAttribute('height', '' + 20);
    this.canvasAlpha.setAttribute('width', '' + w);
    this.canvasAlpha.setAttribute('height', '' + 20);
    var palette = this.ctx.createLinearGradient(0, 0, w, 0);
    palette.addColorStop(1 / 15, '#ff0000');
    palette.addColorStop(4 / 15, '#ffff00');
    palette.addColorStop(5 / 15, '#00ff00');
    palette.addColorStop(9 / 15, '#00ffff');
    palette.addColorStop(12 / 15, '#0000ff');
    palette.addColorStop(14 / 15, '#ff00ff');
    this.ctx.fillStyle = palette;
    this.ctx.fillRect(0, 0, w, h);

    var darkOverlay = this.ctx.createLinearGradient(0, 0, 0, h);
    darkOverlay.addColorStop(0, 'rgba(0, 0, 0, 0)');
    darkOverlay.addColorStop(0.99, 'rgba(0, 0, 0, 1)');
    darkOverlay.addColorStop(1, 'rgba(0, 0, 0, 1)');
    this.ctx.fillStyle = darkOverlay;
    this.ctx.fillRect(0, 0, w, h);

    this.canvas.onmousedown = function (e) {
      _this.selecting = true;
      _this.getPaletteColorAtPoint(e);
    };

    var startLightSelecting = function startLightSelecting(e) {
      _this.lightSelecting = true;
      _this.getColorLightAtClick(e);
    };

    this.canvasLight.onmousedown = startLightSelecting;
    this.colorRegulator.onmousedown = startLightSelecting;
    var startAlphaSelecting = function startAlphaSelecting(e) {
      _this.alphaSelecting = true;
      _this.getAlphaAtClick(e);
    };
    this.canvasAlpha.onmousedown = startAlphaSelecting;
    this.alphaRegulator.onmousedown = startAlphaSelecting;
    this.closeButton.onclick = function () {
      _this.wrapper.setAttribute('hidden', 'true');
      _this.opened = false;
    };
    this.pipetteButton.onclick = function () {
      _this.wrapper.setAttribute('hidden', 'true');
      _this.opened = false;
      _this.choosing = true;
    };

    this.input.onkeyup = function () {
      _this.setActiveColor(_this.input.value, true);
    };
  }

  _createClass(ColorPicker, [{
    key: 'open',
    value: function open(state, addCallback) {
      this.target = state.target;
      this.palleteColor = state.palleteColor;
      this.alpha = state.alpha;
      this.lightPosition = this.lightPosition || this.w - 1;

      this.drawLighter();
      this.colorRegulator.style.left = this.lightPosition + 'px';
      this.alphaRegulator.style.left = Math.round(this.alpha * this.w) + 'px';
      this.regetColor();

      this.wrapper.removeAttribute('hidden');
      this.opened = true;
      this.addCallback = addCallback;
    }
  }, {
    key: 'getPaletteColorAtPoint',
    value: function getPaletteColorAtPoint(e) {
      var x = e.clientX - this.canvas.documentOffsetLeft;
      var y = e.clientY - this.canvas.documentOffsetTop;
      x = x < 1 && 1 || x;
      y = y < 1 && 1 || y;
      x = x > this.w && this.w - 1 || x;
      y = y > this.h && this.h - 1 || y;
      var p = this.ctx.getImageData(x, y, 1, 1).data;
      this.palleteColor = rgbToHex(p[0], p[1], p[2]);
      this.drawLighter();
      this.regetColor();
    }
  }, {
    key: 'regetColor',
    value: function regetColor() {
      var p = this.ctxLight.getImageData(this.lightPosition, 5, 1, 1).data;
      this.setActiveColor(rgbToHex(p[0], p[1], p[2]));
      this.drawAlpher();
    }
  }, {
    key: 'regetAlpha',
    value: function regetAlpha() {
      var p = this.ctxAlpha.getImageData(this.alphaPosition, 5, 1, 1).data;
      this.alpha = p[3] / 255;
      this.setActiveColor(this.color, true);
    }
  }, {
    key: 'getColorLightAtClick',
    value: function getColorLightAtClick(e) {
      var x = e.clientX - this.canvasLight.documentOffsetLeft;
      x = x < 1 && 1 || x;
      x = x > this.w - 1 && this.w - 1 || x;
      this.lightPosition = x;
      this.colorRegulator.style.left = x + 'px';
      this.regetColor();
    }
  }, {
    key: 'getAlphaAtClick',
    value: function getAlphaAtClick(e) {
      var x = e.clientX - this.canvasAlpha.documentOffsetLeft;
      x = x < 1 && 1 || x;
      x = x > this.w - 1 && this.w - 1 || x;
      this.alphaPosition = x;
      this.alphaRegulator.style.left = x + 'px';
      this.regetAlpha();
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(e) {
      if (this.choosing && e.button === 0) {
        // 0 - m1, 1 middle, 2-m2
        this.choosingActive = true;
        this.handleMouseMove(e);
        return true;
      }
      this.choosing = false;
      return false;
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(e) {
      if (this.opened) {
        if (this.selecting) {
          this.getPaletteColorAtPoint(e);
        }
        if (this.lightSelecting) {
          this.getColorLightAtClick(e);
        }
        if (this.alphaSelecting) {
          this.getAlphaAtClick(e);
        }
      } else if (this.choosingActive) {
        var scale = this.main.getScale();
        var x = (e.clientX - this.main.canvas.documentOffsetLeft) * scale;
        x = x < 1 && 1 || x;
        x = x > this.main.size.w - 1 && this.main.size.w - 1 || x;
        var y = (e.clientY - this.main.canvas.documentOffsetTop) * scale;
        y = y < 1 && 1 || y;
        y = y > this.main.size.h - 1 && this.main.size.h - 1 || y;
        var p = this.main.ctx.getImageData(x, y, 1, 1).data;
        var color = rgbToHex(p[0], p[1], p[2]);
        this.callback({
          alphaColor: HexToRGBA(color, 1),
          lightPosition: this.w - 1,
          alpha: 1,
          palleteColor: color,
          target: this.target
        });
        if (this.addCallback !== undefined) {
          this.addCallback({
            alphaColor: HexToRGBA(color, 1),
            lightPosition: this.w - 1,
            alpha: 1,
            palleteColor: color,
            target: this.target
          });
        }
      }
    }
  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      this.selecting = false;
      this.lightSelecting = false;
      this.choosing = false;
      this.choosingActive = false;
      this.alphaSelecting = false;
    }
  }, {
    key: 'setActiveColor',
    value: function setActiveColor(color, ignoreUpdateText) {
      try {
        this.input.style.color = reversedColor(color);
      } catch (e) {
        return;
      }
      this.input.style['background-color'] = color;
      if (ignoreUpdateText === undefined) {
        this.input.value = color;
      }
      this.color = color;
      this.alphaColor = HexToRGBA(color, this.alpha);
      if (this.callback !== undefined && this.opened) {
        this.callback({
          alphaColor: this.alphaColor,
          lightPosition: this.lightPosition,
          alpha: this.alpha,
          palleteColor: this.color,
          target: this.target
        });
      }
      if (this.addCallback !== undefined && this.opened) {
        this.addCallback({
          alphaColor: this.alphaColor,
          lightPosition: this.lightPosition,
          alpha: this.alpha,
          palleteColor: this.color,
          target: this.target
        });
      }
    }
  }, {
    key: 'drawLighter',
    value: function drawLighter() {
      var lightGradient = this.ctxLight.createLinearGradient(0, 0, this.w, 0);
      lightGradient.addColorStop(0, '#ffffff');
      lightGradient.addColorStop(0.05, '#ffffff');
      lightGradient.addColorStop(0.95, this.palleteColor);
      lightGradient.addColorStop(1, this.palleteColor);
      this.ctxLight.fillStyle = lightGradient;
      this.ctxLight.fillRect(0, 0, this.w, 15);
    }
  }, {
    key: 'drawAlpher',
    value: function drawAlpher() {
      this.ctxAlpha.clearRect(0, 0, this.w, 15);
      var lightGradient = this.ctxAlpha.createLinearGradient(0, 0, this.w, 0);
      lightGradient.addColorStop(0, 'rgba(255,255,255,0)');
      lightGradient.addColorStop(0.05, 'rgba(255,255,255,0)');
      lightGradient.addColorStop(0.95, this.color);
      lightGradient.addColorStop(1, this.color);
      this.ctxAlpha.fillStyle = lightGradient;
      this.ctxAlpha.fillRect(0, 0, this.w, 15);
    }
  }], [{
    key: 'html',
    value: function html() {
      return '' + '<div class="ptro-color-widget-wrapper" hidden>' + '<div class="ptro-color-widget">' + '<div class="ptro-pallet ptro-color-main">' + '<canvas></canvas>' + '<canvas class="ptro-canvas-light"></canvas>' + '<span class="ptro-color-light-regulator ptro-bordered-control"></span>' + '<canvas class="ptro-canvas-alpha"></canvas>' + '<span class="alpha-checkers"></span>' + '<span class="ptro-color-alpha-regulator ptro-bordered-control"></span>' + '<div class="ptro-colors"></div>' + '<div class="ptro-color-edit">' + '<button class="ptro-icon-btn ptro-pipette ptro-color-control" style="float: left; margin-right: 5px">' + '<i class="ptro-icon ptro-icon-pipette"></i>' + '</button>' + '<input class="ptro-input ptro-color" type="text" size="7"/>' + '<button class="ptro-named-btn ptro-close-color-picker ptro-color-control" >' + ((0, _translation.tr)('close') + '</button>') + '</div>' + '</div>' + '</div>' + '</div>';
    }
  }]);

  return ColorPicker;
}();

exports.default = ColorPicker;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _translation = __webpack_require__(0);

var _utils = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Inserter = function () {
  function Inserter() {
    var _this = this;

    _classCallCheck(this, Inserter);

    this.pasteOptions = {
      fit: {
        handle: function handle(img) {
          _this.main.fitImage(img);
        }
      },
      extend_down: {
        handle: function handle(img) {
          _this.tmpImg = img;
          var oldH = _this.main.size.h;
          var oldW = _this.main.size.w;
          var newH = oldH + img.naturalHeight;
          var newW = Math.max(oldW, img.naturalWidth);
          var tmpData = _this.ctx.getImageData(0, 0, _this.main.size.w, _this.main.size.h);
          _this.main.resize(newW, newH);
          _this.main.clearBackground();
          _this.ctx.putImageData(tmpData, 0, 0);
          _this.main.adjustSizeFull();
          if (img.naturalWidth < oldW) {
            var offset = Math.round((oldW - img.naturalWidth) / 2);
            _this.main.select.placeAt(offset, oldH, offset, 0, img);
          } else {
            _this.main.select.placeAt(0, oldH, 0, 0, img);
          }
          _this.worklog.captureState();
        }
      },
      extend_right: {
        handle: function handle(img) {
          _this.tmpImg = img;
          var oldH = _this.main.size.h;
          var oldW = _this.main.size.w;
          var newW = oldW + img.naturalWidth;
          var newH = Math.max(oldH, img.naturalHeight);
          var tmpData = _this.ctx.getImageData(0, 0, _this.main.size.w, _this.main.size.h);
          _this.main.resize(newW, newH);
          _this.main.clearBackground();
          _this.ctx.putImageData(tmpData, 0, 0);
          _this.main.adjustSizeFull();
          if (img.naturalHeight < oldH) {
            var offset = Math.round((oldH - img.naturalHeight) / 2);
            _this.main.select.placeAt(oldW, offset, 0, offset, img);
          } else {
            _this.main.select.placeAt(oldW, 0, 0, 0, img);
          }
          _this.worklog.captureState();
        }
      },
      over: {
        handle: function handle(img) {
          _this.tmpImg = img;
          var oldH = _this.main.size.h;
          var oldW = _this.main.size.w;
          if (img.naturalHeight <= oldH && img.naturalWidth <= oldW) {
            _this.main.select.placeAt(0, 0, oldW - img.naturalWidth, oldH - img.naturalHeight, img);
          } else if (img.naturalWidth / img.naturalHeight > oldW / oldH) {
            var newH = oldW * (img.naturalHeight / img.naturalWidth);
            _this.main.select.placeAt(0, 0, 0, oldH - newH, img);
          } else {
            var newW = oldH * (img.naturalWidth / img.naturalHeight);
            _this.main.select.placeAt(0, 0, oldW - newW, 0, img);
          }
          _this.worklog.captureState();
        }
      }
    };
  }

  _createClass(Inserter, [{
    key: 'init',
    value: function init(main) {
      var _this2 = this;

      this.CLIP_DATA_MARKER = 'painterro-data:';
      this.ctx = main.ctx;
      this.main = main;
      this.worklog = main.worklog;
      this.selector = main.wrapper.querySelector('.ptro-paster-select-wrapper');
      this.cancelChoosing();
      this.img = null;
      Object.keys(this.pasteOptions).forEach(function (k) {
        var o = _this2.pasteOptions[k];
        _this2.main.doc.getElementById(o.id).onclick = function () {
          if (_this2.loading) {
            _this2.doLater = o.handle;
          } else {
            o.handle(_this2.img);
          }
          _this2.cancelChoosing();
        };
      });
      this.loading = false;
      this.doLater = null;
    }
  }, {
    key: 'insert',
    value: function insert(x, y, w, h) {
      this.main.ctx.drawImage(this.tmpImg, x, y, w, h);
      this.main.worklog.reCaptureState();
    }
  }, {
    key: 'cancelChoosing',
    value: function cancelChoosing() {
      this.selector.setAttribute('hidden', '');
      this.waitChoice = false;
    }
  }, {
    key: 'loaded',
    value: function loaded(img) {
      this.img = img;
      this.loading = false;
      if (this.doLater) {
        this.doLater(img);
        this.doLater = null;
      }
    }
  }, {
    key: 'handleOpen',
    value: function handleOpen(source) {
      var _this3 = this;

      var img = new Image();
      var empty = this.main.worklog.empty;
      img.onload = function () {
        if (empty) {
          _this3.main.fitImage(img);
        } else {
          _this3.loaded(img);
        }
        _this3.finishLoading();
      };
      this.startLoading();
      img.src = source;
      if (!empty) {
        this.selector.removeAttribute('hidden');
        this.waitChoice = true;
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      if (this.waitChoice && evt.keyCode === _utils.KEYS.esc) {
        this.cancelChoosing();
      }
      if (!this.waitChoice && !this.main.select.imagePlaced && this.main.select.shown && evt.keyCode === _utils.KEYS.c && (evt.ctrlKey || evt.metaKey)) {
        var a = this.main.select.area;
        var w = a.bottoml[0] - a.topl[0];
        var h = a.bottoml[1] - a.topl[1];
        var tmpCan = this.main.doc.createElement('canvas');
        tmpCan.width = w;
        tmpCan.height = h;
        var tmpCtx = tmpCan.getContext('2d');
        tmpCtx.drawImage(this.main.canvas, -a.topl[0], -a.topl[1]);
        (0, _utils.copyToClipboard)('' + this.CLIP_DATA_MARKER + tmpCan.toDataURL());
      }
    }
  }, {
    key: 'startLoading',
    value: function startLoading() {
      this.loading = true;
      var btn = this.main.doc.getElementById(this.main.toolByName.open.buttonId);
      var icon = this.main.doc.querySelector('#' + this.main.toolByName.open.buttonId + ' > i');
      if (btn) {
        btn.setAttribute('disabled', 'true');
      }
      if (icon) {
        icon.className = 'ptro-icon ptro-icon-loading ptro-spinning';
      }
    }
  }, {
    key: 'finishLoading',
    value: function finishLoading() {
      var btn = this.main.doc.getElementById(this.main.toolByName.open.buttonId);
      var icon = this.main.doc.querySelector('#' + this.main.toolByName.open.buttonId + ' > i');
      if (btn) {
        btn.removeAttribute('disabled');
      }
      if (icon) {
        icon.className = 'ptro-icon ptro-icon-open';
      }
    }
  }, {
    key: 'html',
    value: function html() {
      var _this4 = this;

      var buttons = '';
      Object.keys(this.pasteOptions).forEach(function (k) {
        var o = _this4.pasteOptions[k];
        o.id = (0, _utils.genId)();
        buttons += '<button id="' + o.id + '" class="ptro-selector-btn ptro-color-control">' + ('<div><i class="ptro-icon ptro-icon-paste_' + k + '"></i></div>') + ('<div>' + (0, _translation.tr)('pasteOptions.' + k) + '</div>') + '</button>';
      });
      return '<div class="ptro-paster-select-wrapper" hidden><div class="ptro-paster-select"><div class="ptro-in">' + ('<div class="ptro-paste-label">' + (0, _translation.tr)('pasteOptions.how_to_paste') + '</div>' + buttons + '</div></div></div>');
    }
  }]);

  return Inserter;
}();

exports.default = Inserter;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setParam = setParam;
exports.setDefaults = setDefaults;

var _colorPicker = __webpack_require__(4);

var _translation = __webpack_require__(0);

var _translation2 = _interopRequireDefault(_translation);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = 'painterro-data';

var settings = {};

function loadSettings() {
  try {
    settings = JSON.parse(localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    console.error('Unable get from localstorage: ' + e);
  }
  if (!settings) {
    settings = {};
  }
}

function setParam(name, val) {
  settings[name] = val;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    console.error('Unable save to localstorage: ' + e);
  }
}

function setDefaults(parameters) {
  loadSettings();
  var params = parameters || {};
  params.activeColor = settings.activeColor || params.activeColor || '#ff0000';
  params.activeColorAlpha = settings.activeColorAlpha || params.activeColorAlpha || 1.0;
  params.activeAlphaColor = (0, _colorPicker.HexToRGBA)(params.activeColor, params.activeColorAlpha);

  params.activeFillColor = settings.activeFillColor || params.activeFillColor || '#000000';
  params.activeFillColorAlpha = settings.activeFillColorAlpha || params.activeFillColorAlpha || 0.0;
  params.activeFillAlphaColor = (0, _colorPicker.HexToRGBA)(params.activeFillColor, params.activeFillColorAlpha);

  params.initText = params.initText || null;
  params.initTextColor = params.initTextColor || '#808080';
  params.initTextStyle = params.initTextStyle || '26px \'Open Sans\', sans-serif';
  params.defaultLineWidth = settings.defaultLineWidth || params.defaultLineWidth || 5;
  params.defaultFontSize = settings.defaultFontSize || params.defaultFontSize || 24;
  params.backgroundFillColor = settings.backgroundFillColor || params.backgroundFillColor || '#ffffff';
  params.hiddenTools = params.hiddenTools || [];

  params.colorScheme = params.colorScheme || {};
  params.colorScheme.main = params.colorScheme.main || '#dbebff';
  params.colorScheme.control = params.colorScheme.control || '#abc6ff';
  params.colorScheme.controlContent = params.colorScheme.controlContent || '#000000';
  params.colorScheme.hoverControl = params.colorScheme.hoverControl || params.colorScheme.control;
  params.colorScheme.hoverControlContent = params.colorScheme.hoverControlContent || '#1a3d67';

  params.colorScheme.activeControl = params.colorScheme.activeControl || '#7485B1';
  params.colorScheme.activeControlContent = params.colorScheme.activeControlContent || params.colorScheme.main;
  params.colorScheme.inputBorderColor = params.colorScheme.inputBorderColor || params.colorScheme.main;
  params.colorScheme.inputBackground = params.colorScheme.inputBackground || '#ffffff';
  params.colorScheme.inputText = params.colorScheme.inputText || params.colorScheme.activeControl;
  params.colorScheme.backgroundColor = params.colorScheme.backgroundColor || '#999999';
  params.colorScheme.dragOverBarColor = params.colorScheme.dragOverBarColor || '#899dff';

  params.defaultSize = params.defaultSize || 'fill';
  params.defaultPixelSize = params.defaultPixelSize || 4;
  if (params.defaultSize === 'fill') {
    params.defaultSize = {
      width: 'fill',
      height: 'fill'
    };
  } else {
    var wh = params.defaultSize.split('x');
    params.defaultSize = {
      width: (0, _utils.trim)(wh[0]),
      height: (0, _utils.trim)(wh[1])
    };
  }

  if (params.translation) {
    var name = params.translation.name;
    _translation2.default.get().addTranslation(name, params.translation.strings);
    _translation2.default.get().activate(name);
  }

  params.styles = '.ptro-color-main{\n        background-color: ' + params.colorScheme.main + ';\n        color: ' + params.colorScheme.controlContent + '}\n    .ptro-color-control{\n        background-color: ' + params.colorScheme.control + ';\n        color:' + params.colorScheme.controlContent + '}\n    button.ptro-color-control:hover:not(.ptro-color-active-control):not([disabled]){\n        background-color: ' + params.colorScheme.hoverControl + ';\n        color:' + params.colorScheme.hoverControlContent + '}    \n    .ptro-bordered-control{border-color: ' + params.colorScheme.activeControl + '}\n    .ptro-input, .ptro-input:focus {\n      border: 1px solid ' + params.colorScheme.inputBorderColor + ';\n      background-color: ' + params.colorScheme.inputBackground + ';\n      color: ' + params.colorScheme.inputText + '\n    }\n    .ptro-bar-dragover{background-color:' + params.colorScheme.dragOverBarColor + '}\n    .ptro-color,.ptro-bordered-btn{\n      border: 1px solid ' + params.colorScheme.inputBorderColor + ';\n    }\n    .ptro-color-control:active:enabled {\n        background-color: ' + params.colorScheme.activeControl + ';\n        color: ' + params.colorScheme.activeControlContent + '}\n    .ptro-color-active-control{\n        background-color: ' + params.colorScheme.activeControl + ';\n        color:' + params.colorScheme.activeControlContent + '}\n    .ptro-wrapper{background-color:' + params.colorScheme.backgroundColor + ';}}';

  return params;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrimitiveTool = function () {
  function PrimitiveTool(main) {
    _classCallCheck(this, PrimitiveTool);

    this.ctx = main.ctx;
    this.el = main.toolContainer;
    this.main = main;
    this.helperCanvas = document.createElement('canvas');
    this.canvas = main.canvas;
  }

  _createClass(PrimitiveTool, [{
    key: 'activate',
    value: function activate(type) {
      this.type = type;
      this.state = {};
      if (type === 'line' || type === 'brush') {
        this.ctx.lineJoin = 'round';
      } else {
        this.ctx.lineJoin = 'miter';
      }
    }
  }, {
    key: 'setLineWidth',
    value: function setLineWidth(width) {
      this.lineWidth = width;
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      this.activate(this.type);
      var mainClass = event.target.classList[0];
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.strokeStyle = this.main.colorWidgetState.line.alphaColor;
      this.ctx.fillStyle = this.main.colorWidgetState.fill.alphaColor;
      var scale = this.main.getScale();
      this.ctx.lineCap = 'round';
      if (mainClass === 'ptro-crp-el' || mainClass === 'ptro-zoomer') {
        this.tmpData = this.ctx.getImageData(0, 0, this.main.size.w, this.main.size.h);
        if (this.type === 'brush') {
          this.state.cornerMarked = true;
          var cord = [event.clientX - this.el.documentOffsetLeft + this.main.wrapper.scrollLeft, event.clientY - this.el.documentOffsetTop + this.main.wrapper.scrollTop];
          var cur = {
            x: cord[0] * scale,
            y: cord[1] * scale
          };

          this.points = [cur];
          this.drawBrushPath();
        } else {
          this.state.cornerMarked = true;
          this.centerCord = [event.clientX - this.el.documentOffsetLeft + this.main.wrapper.scrollLeft, event.clientY - this.el.documentOffsetTop + this.main.wrapper.scrollTop];
          this.centerCord = [this.centerCord[0] * scale, this.centerCord[1] * scale];
        }
      }
    }
  }, {
    key: 'drawBrushPath',
    value: function drawBrushPath() {
      var _this = this;

      var smPoints = this.points;

      if (smPoints.length === 1) {
        this.ctx.beginPath();
        this.ctx.lineWidth = 0;
        this.ctx.fillStyle = this.main.colorWidgetState.line.alphaColor;
        this.ctx.arc(this.points[0].x, this.points[0].y, this.lineWidth / 2, this.lineWidth / 2, 0, 2 * Math.PI);
        this.ctx.fill();
        this.ctx.closePath();
      } else {
        this.ctx.beginPath();
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.strokeStyle = this.main.colorWidgetState.line.alphaColor;
        this.ctx.fillStyle = this.main.colorWidgetState.fill.alphaColor;

        this.ctx.moveTo(this.points[0].x, this.points[0].y);
        var last = void 0;
        smPoints.slice(1).forEach(function (p) {
          _this.ctx.lineTo(p.x, p.y);
          last = p;
        });
        if (last) {
          this.ctx.moveTo(last.x, last.y);
        }
        this.ctx.stroke();
        this.ctx.closePath();
      }
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (this.state.cornerMarked) {
        this.ctx.putImageData(this.tmpData, 0, 0);

        this.curCord = [event.clientX - this.el.documentOffsetLeft + this.main.wrapper.scrollLeft, event.clientY - this.el.documentOffsetTop + this.main.wrapper.scrollTop];
        var scale = this.main.getScale();
        this.curCord = [this.curCord[0] * scale, this.curCord[1] * scale];

        if (this.type === 'brush') {
          var prevLast = this.points.slice(-1)[0];
          var cur = {
            x: this.curCord[0],
            y: this.curCord[1]
          };

          if ((0, _utils.distance)(prevLast, cur) > 5) {
            this.points.push(cur);
          }
          this.drawBrushPath();
        } else if (this.type === 'line') {
          if (event.ctrlKey || event.shiftKey) {
            var deg = Math.atan(-(this.curCord[1] - this.centerCord[1]) / (this.curCord[0] - this.centerCord[0])) * 180 / Math.PI;
            if (Math.abs(deg) < 45.0 / 2) {
              this.curCord[1] = this.centerCord[1];
            } else if (Math.abs(deg) > (45 + 45.0) / 2) {
              this.curCord[0] = this.centerCord[0];
            } else {
              var base = (Math.abs(this.curCord[0] - this.centerCord[0]) - Math.abs(this.centerCord[1] - this.curCord[1])) / 2;

              this.curCord[0] -= base * (this.centerCord[0] < this.curCord[0] ? 1 : -1);
              this.curCord[1] -= base * (this.centerCord[1] > this.curCord[1] ? 1 : -1);
            }
          }
          this.ctx.beginPath();
          this.ctx.moveTo(this.centerCord[0], this.centerCord[1]);
          this.ctx.lineTo(this.curCord[0], this.curCord[1]);
          this.ctx.closePath();
          this.ctx.stroke();
        } else if (this.type === 'rect') {
          this.ctx.beginPath();

          var tl = [Math.min(this.curCord[0], this.centerCord[0]), Math.min(this.curCord[1], this.centerCord[1])];

          var w = Math.abs(this.curCord[0] - this.centerCord[0]);
          var h = Math.abs(this.curCord[1] - this.centerCord[1]);

          if (event.ctrlKey || event.shiftKey) {
            var min = Math.min(Math.abs(w), Math.abs(h));
            w = min * Math.sign(w);
            h = min * Math.sign(h);
          }
          var halfLW = Math.floor(this.lineWidth / 2);
          var oddCorrecter = this.lineWidth % 2;
          this.ctx.rect(tl[0] + halfLW, tl[1] + halfLW, w - this.lineWidth + oddCorrecter, h - this.lineWidth + oddCorrecter);
          this.ctx.fill();
          this.ctx.strokeRect(tl[0], tl[1], w, h);
          this.ctx.closePath();
        } else if (this.type === 'ellipse') {
          this.ctx.beginPath();
          var x1 = this.centerCord[0];
          var y1 = this.centerCord[1];
          var _w = this.curCord[0] - x1;
          var _h = this.curCord[1] - y1;

          if (event.ctrlKey || event.shiftKey) {
            var _min = Math.min(Math.abs(_w), Math.abs(_h));
            _w = _min * Math.sign(_w);
            _h = _min * Math.sign(_h);
          }

          var rX = Math.abs(_w);
          var rY = Math.abs(_h);

          var tlX = Math.min(x1, x1 + _w);
          var tlY = Math.min(y1, y1 + _h);

          this.ctx.save();
          var xScale = 1;
          var yScale = 1;
          var radius = void 0;
          var hR = rX / 2;
          var vR = rY / 2;
          if (rX > rY) {
            yScale = rX / rY;
            radius = hR;
          } else {
            xScale = rY / rX;
            radius = vR;
          }
          this.ctx.scale(1 / xScale, 1 / yScale);
          this.ctx.arc((tlX + hR) * xScale, (tlY + vR) * yScale, radius, 0, 2 * Math.PI);
          this.ctx.restore();
          this.ctx.fill();
          this.ctx.stroke();

          this.ctx.beginPath();
        }
      }
    }
  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      if (this.state.cornerMarked) {
        this.state.cornerMarked = false;
        this.main.worklog.captureState();
      }
    }
  }, {
    key: 'setPixelSize',
    value: function setPixelSize(size) {
      this.pixelSize = size;
    }
  }]);

  return PrimitiveTool;
}();

exports.default = PrimitiveTool;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _translation = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Resizer = function () {
  function Resizer(main) {
    var _this = this;

    _classCallCheck(this, Resizer);

    this.main = main;

    this.wrapper = main.wrapper.querySelector('.ptro-resize-widget-wrapper');
    this.inputW = main.wrapper.querySelector('.ptro-resize-widget-wrapper .ptro-resize-width-input');
    this.inputH = main.wrapper.querySelector('.ptro-resize-widget-wrapper .ptro-resize-heigth-input');

    this.linkButton = main.wrapper.querySelector('.ptro-resize-widget-wrapper button.ptro-link');
    this.linkButtonIcon = main.wrapper.querySelector('.ptro-resize-widget-wrapper button.ptro-link i');
    this.closeButton = main.wrapper.querySelector('.ptro-resize-widget-wrapper button.ptro-close');
    this.scaleButton = main.wrapper.querySelector('.ptro-resize-widget-wrapper button.ptro-scale');
    this.resizeButton = main.wrapper.querySelector('.ptro-resize-widget-wrapper button.ptro-resize');
    this.linked = true;
    this.closeButton.onclick = function () {
      _this.startClose();
    };

    this.scaleButton.onclick = function () {
      var origW = _this.main.size.w;
      var origH = _this.main.size.h;

      var tmpData = _this.main.canvas.toDataURL();

      _this.main.resize(_this.newW, _this.newH);

      _this.main.ctx.save();
      // this.ctx.translate(h / 2, w / 2);
      _this.main.ctx.scale(_this.newW / origW, _this.newH / origH);
      var img = new Image();
      img.onload = function () {
        _this.main.ctx.drawImage(img, 0, 0);
        _this.main.adjustSizeFull();
        _this.main.ctx.restore();
        _this.main.worklog.captureState();
        _this.startClose();
      };
      img.src = tmpData;
    };

    this.resizeButton.onclick = function () {
      var tmpData = _this.main.canvas.toDataURL();
      _this.main.resize(_this.newW, _this.newH);
      _this.main.clearBackground();
      var img = new Image();
      img.onload = function () {
        _this.main.ctx.drawImage(img, 0, 0);
        _this.main.adjustSizeFull();
        _this.main.worklog.captureState();
        _this.startClose();
      };
      img.src = tmpData;
    };

    this.linkButton.onclick = function () {
      _this.linked = !_this.linked;
      if (_this.linked) {
        _this.linkButtonIcon.className = 'ptro-icon ptro-icon-linked';
      } else {
        _this.linkButtonIcon.className = 'ptro-icon ptro-icon-unlinked';
      }
    };

    this.inputW.oninput = function () {
      _this.newW = _this.inputW.value;
      if (_this.linked) {
        var ratio = _this.main.size.ratio;
        _this.newH = Math.round(_this.newW / ratio);
        _this.inputH.value = _this.newH;
      }
    };
    this.inputH.oninput = function () {
      _this.newH = _this.inputH.value;
      if (_this.linked) {
        var ratio = _this.main.size.ratio;
        _this.newW = Math.round(_this.newH * ratio);
        _this.inputW.value = _this.newW;
      }
    };
  }

  _createClass(Resizer, [{
    key: 'open',
    value: function open() {
      this.wrapper.removeAttribute('hidden');
      this.opened = true;
      this.newW = this.main.size.w;
      this.newH = this.main.size.h;
      this.inputW.value = this.newW;
      this.inputH.value = this.newH;
    }
  }, {
    key: 'close',
    value: function close() {
      this.wrapper.setAttribute('hidden', 'true');
      this.opened = false;
    }
  }, {
    key: 'startClose',
    value: function startClose() {
      this.main.closeActiveTool();
    }
  }], [{
    key: 'html',
    value: function html() {
      return '' + '<div class="ptro-resize-widget-wrapper" hidden>' + '<div class="ptro-resize-widget ptro-color-main">' + '<div style="display: inline-block">' + '<table>' + '<tr>' + ('<td class="ptro-label ptro-resize-table-left">' + (0, _translation.tr)('width') + '</td>') + '<td>' + '<input class="ptro-input ptro-resize-width-input" type="number" min="0" max="3000" step="1"/>' + '</td>' + '</tr>' + '<tr>' + ('<td class="ptro-label ptro-resize-table-left">' + (0, _translation.tr)('height') + '</td>') + '<td>' + '<input class="ptro-input ptro-resize-heigth-input" type="number" min="0" max="3000" step="1"/>' + '</td>' + '</tr>' + '</table>' + '</div>' + '<div class="ptro-resize-link-wrapper">' + ('<button class="ptro-icon-btn ptro-link ptro-color-control" title="' + (0, _translation.tr)('keepRatio') + '">') + '<i class="ptro-icon ptro-icon-linked" style="font-size: 18px;"></i>' + '</button>' + '</div>' + '<div></div>' + '<div style="margin-top: 40px;">' + '<button class="ptro-named-btn ptro-resize ptro-color-control">' + ((0, _translation.tr)('resizeResize') + '</button>') + '<button class="ptro-named-btn ptro-scale ptro-color-control">' + ((0, _translation.tr)('resizeScale') + '</button>') + '<button class="ptro-named-btn ptro-close ptro-color-control">' + ((0, _translation.tr)('cancel') + '</button>') + '</div>' + '</div>' + '</div>';
    }
  }]);

  return Resizer;
}();

exports.default = Resizer;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PainterroSelecter = function () {
  function PainterroSelecter(main, selectionCallback) {
    _classCallCheck(this, PainterroSelecter);

    this.main = main;
    this.canvas = main.canvas;
    this.ctx = main.ctx;
    this.areaionCallback = selectionCallback;
    this.shown = false;
    this.area = {
      el: main.toolContainer,
      rect: document.querySelector('#' + main.id + ' .ptro-crp-rect')
    };
    this.imagePlaced = false;
  }

  _createClass(PainterroSelecter, [{
    key: 'activate',
    value: function activate() {
      this.area.activated = true;
      this.areaionCallback(false);
    }
  }, {
    key: 'doCrop',
    value: function doCrop() {
      var _this = this;

      var img = new Image();
      img.onload = function () {
        _this.main.resize(_this.area.bottoml[0] - _this.area.topl[0], _this.area.bottoml[1] - _this.area.topl[1]);
        _this.main.ctx.drawImage(img, -_this.area.topl[0], -_this.area.topl[1]);
        _this.main.adjustSizeFull();
        _this.main.worklog.captureState();
      };
      img.src = this.canvas.toDataURL();
    }
  }, {
    key: 'doPixelize',
    value: function doPixelize() {
      var c = this.area.topl;
      var size = [this.area.bottoml[0] - this.area.topl[0], this.area.bottoml[1] - this.area.topl[1]];

      this.pixelSize = Math.min(size[0], size[1]) / 5;
      var pxData = [];
      var pxSize = [size[0] / this.pixelSize, size[1] / this.pixelSize];
      for (var i = 0; i < pxSize[0]; i += 1) {
        var row = [];
        for (var j = 0; j < pxSize[1]; j += 1) {
          row.push([0, 0, 0, 0, 0]);
        }
        pxData.push(row);
      }
      var data = this.ctx.getImageData(c[0], c[1], size[0], size[1]);
      for (var _i = 0; _i < size[0]; _i += 1) {
        for (var _j = 0; _j < size[1]; _j += 1) {
          var ii = Math.floor(_i / this.pixelSize);
          var jj = Math.floor(_j / this.pixelSize);
          var base = (_j * size[0] + _i) * 4;
          pxData[ii][jj][0] += data.data[base];
          pxData[ii][jj][1] += data.data[base + 1];
          pxData[ii][jj][2] += data.data[base + 2];
          pxData[ii][jj][3] += data.data[base + 3];
          pxData[ii][jj][4] += 1;
        }
      }
      var d = new ImageData(1, 1);
      for (var _i2 = 0; _i2 < pxSize[0]; _i2 += 1) {
        for (var _j2 = 0; _j2 < pxSize[1]; _j2 += 1) {
          var s = pxData[_i2][_j2][4];
          d.data[0] = pxData[_i2][_j2][0] / s;
          d.data[1] = pxData[_i2][_j2][1] / s;
          d.data[2] = pxData[_i2][_j2][2] / s;
          d.data[3] = pxData[_i2][_j2][3] / s;
          var baseX = c[0] + _i2 * this.pixelSize;
          var baseY = c[1] + _j2 * this.pixelSize;
          for (var k = 0; k < this.pixelSize; k += 1) {
            for (var n = 0; n < this.pixelSize; n += 1) {
              this.ctx.putImageData(d, baseX + k, baseY + n);
            }
          }
        }
      }
      this.main.worklog.captureState();
    }
  }, {
    key: 'getScale',
    value: function getScale() {
      return this.canvas.clientWidth / this.canvas.getAttribute('width');
    }
  }, {
    key: 'reCalcCropperCords',
    value: function reCalcCropperCords() {
      var ratio = this.getScale();
      this.area.topl = [Math.round((this.area.rect.documentOffsetLeft - this.area.el.documentOffsetLeft) / ratio), Math.round((this.area.rect.documentOffsetTop - this.area.el.documentOffsetTop) / ratio)];

      this.area.bottoml = [Math.round(this.area.topl[0] + (this.area.rect.clientWidth + 2) / ratio), Math.round(this.area.topl[1] + (this.area.rect.clientHeight + 2) / ratio)];
      // console.log('recalced cords', ratio, this.area.topl, this.area.bottoml);
    }
  }, {
    key: 'placeAt',
    value: function placeAt(l, t, r, b, img) {
      this.main.closeActiveTool(true);
      this.main.setActiveTool(this.main.toolByName.select);
      var scale = this.getScale();
      this.setLeft(l * scale);
      this.setTop(t * scale);
      this.setRight(r * scale);
      this.setBottom(b * scale);
      var tmpCan = document.createElement('canvas');
      tmpCan.width = img.naturalWidth;
      tmpCan.height = img.naturalHeight;
      var tmpCtx = tmpCan.getContext('2d');
      tmpCtx.drawImage(img, 0, 0);
      this.placedData = tmpCan.toDataURL('image/png');
      var lowScale = 1000 / Math.max(img.naturalWidth, img.naturalHeight);
      if (lowScale >= 1) {
        this.placedDataLow = this.placedData;
      } else {
        tmpCan.width = img.naturalWidth * lowScale;
        tmpCan.height = img.naturalHeight * lowScale;
        tmpCtx.scale(lowScale, lowScale);
        tmpCtx.drawImage(img, 0, 0);
        this.placedDataLow = tmpCan.toDataURL('image/png');
      }
      this.main.select.area.rect.style['background-image'] = 'url(' + this.placedData + ')';
      this.show();
      this.reCalcCropperCords();
      this.imagePlaced = true;
      this.placedRatio = img.naturalWidth / img.naturalHeight;
    }
  }, {
    key: 'finishPlacing',
    value: function finishPlacing() {
      this.imagePlaced = false;
      this.main.select.area.rect.style['background-image'] = 'none';
      this.main.inserter.insert(this.area.topl[0], this.area.topl[1], this.area.bottoml[0] - this.area.topl[0], this.area.bottoml[1] - this.area.topl[1]);
    }
  }, {
    key: 'cancelPlacing',
    value: function cancelPlacing() {
      this.imagePlaced = false;
      this.main.select.area.rect.style['background-image'] = 'none';
      this.hide();
      this.main.worklog.undoState();
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      this.main.inserter.handleKeyDown(evt);
      if (this.shown && this.imagePlaced) {
        if (evt.keyCode === _utils.KEYS.enter) {
          this.finishPlacing();
        } else if (evt.keyCode === _utils.KEYS.esc) {
          this.cancelPlacing();
        }
      }
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var _this2 = this;

      var mainClass = event.target.classList[0];
      var mousDownCallbacks = {
        'ptro-crp-el': function ptroCrpEl() {
          if (_this2.area.activated) {
            if (_this2.imagePlaced) {
              _this2.finishPlacing();
            }
            var x = event.clientX - _this2.area.el.documentOffsetLeft + _this2.main.wrapper.scrollLeft;
            var y = event.clientY - _this2.area.el.documentOffsetTop + _this2.main.wrapper.scrollTop;

            _this2.setLeft(x);
            _this2.setTop(y);
            _this2.setRight(_this2.area.el.clientWidth - x);
            _this2.setBottom(_this2.area.el.clientHeight - y);

            _this2.reCalcCropperCords();
            _this2.area.resizingB = true;
            _this2.area.resizingR = true;
            _this2.hide();
          }
        },
        'ptro-crp-rect': function ptroCrpRect() {
          _this2.area.moving = true;
          _this2.area.xHandle = event.clientX - _this2.area.rect.documentOffsetLeft + _this2.main.wrapper.scrollLeft;
          _this2.area.yHandle = event.clientY - _this2.area.rect.documentOffsetTop + _this2.main.wrapper.scrollTop;
        },
        'ptro-crp-tr': function ptroCrpTr() {
          _this2.area.resizingT = true;
          _this2.area.resizingR = true;
        },
        'ptro-crp-br': function ptroCrpBr() {
          _this2.area.resizingB = true;
          _this2.area.resizingR = true;
        },
        'ptro-crp-bl': function ptroCrpBl() {
          _this2.area.resizingB = true;
          _this2.area.resizingL = true;
        },
        'ptro-crp-tl': function ptroCrpTl() {
          _this2.area.resizingT = true;
          _this2.area.resizingL = true;
        },
        'ptro-crp-t': function ptroCrpT() {
          _this2.area.resizingT = true;
        },
        'ptro-crp-r': function ptroCrpR() {
          _this2.area.resizingR = true;
        },
        'ptro-crp-b': function ptroCrpB() {
          _this2.area.resizingB = true;
        },
        'ptro-crp-l': function ptroCrpL() {
          _this2.area.resizingL = true;
        }
      };
      if (mainClass in mousDownCallbacks) {
        mousDownCallbacks[mainClass]();
        if (this.imagePlaced) {
          this.main.select.area.rect.style['background-image'] = 'url(' + this.placedDataLow + ')';
        }
      }
    }
  }, {
    key: 'setLeft',
    value: function setLeft(v) {
      this.left = v;
      this.area.rect.style.left = v + 'px';
    }
  }, {
    key: 'setRight',
    value: function setRight(v) {
      this.right = v;
      this.area.rect.style.right = v + 'px';
    }
  }, {
    key: 'setTop',
    value: function setTop(v) {
      this.top = v;
      this.area.rect.style.top = v + 'px';
    }
  }, {
    key: 'setBottom',
    value: function setBottom(v) {
      this.bottom = v;
      this.area.rect.style.bottom = v + 'px';
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (!this.area.activated) {
        return;
      }
      if (this.area.moving) {
        var newLeft = event.clientX - this.area.el.documentOffsetLeft - this.area.xHandle + this.main.wrapper.scrollLeft;
        if (newLeft < 0) {
          newLeft = 0;
        } else if (newLeft + this.area.rect.clientWidth > this.area.el.clientWidth - 2) {
          newLeft = this.area.el.clientWidth - this.area.rect.clientWidth - 2;
        }
        var hDelta = newLeft - this.left;
        this.setLeft(newLeft);
        this.setRight(this.right - hDelta);

        var newTop = event.clientY - this.area.el.documentOffsetTop - this.area.yHandle + this.main.wrapper.scrollTop;
        if (newTop < 0) {
          newTop = 0;
        } else if (newTop + this.area.rect.clientHeight > this.area.el.clientHeight - 2) {
          newTop = this.area.el.clientHeight - this.area.rect.clientHeight - 2;
        }
        var vDelta = newTop - this.top;
        this.setTop(newTop);
        this.setBottom(this.bottom - vDelta);
        this.reCalcCropperCords();
      } else {
        var resizing = false;
        if (this.area.resizingL) {
          resizing = true;
          var absLeft = this.fixCropperLeft(event.clientX + this.main.wrapper.scrollLeft);
          this.setLeft(absLeft - this.area.el.documentOffsetLeft);
          this.reCalcCropperCords();
        }
        if (this.area.resizingR) {
          resizing = true;
          var absRight = this.fixCropperRight(event.clientX + this.main.wrapper.scrollLeft);
          this.setRight(this.area.el.clientWidth + this.area.el.documentOffsetLeft - absRight);
          this.reCalcCropperCords();
        }
        if (this.area.resizingT) {
          resizing = true;
          var absTop = this.fixCropperTop(event.clientY + this.main.wrapper.scrollTop);
          this.setTop(absTop - this.area.el.documentOffsetTop);
          this.reCalcCropperCords();
        }
        if (this.area.resizingB) {
          resizing = true;
          var absBottom = this.fixCropperBottom(event.clientY + this.main.wrapper.scrollTop);
          this.setBottom(this.area.el.clientHeight + this.area.el.documentOffsetTop - absBottom);
          this.reCalcCropperCords();
        }
        if (this.imagePlaced && !(event.ctrlKey || event.shiftKey)) {
          if (this.area.resizingT) {
            if (this.area.resizingL) {
              this.leftKeepRatio();
            } else {
              this.rightKeepRatio();
            }
            this.topKeepRatio();
            this.reCalcCropperCords();
          }
          if (this.area.resizingB) {
            if (this.area.resizingL) {
              this.leftKeepRatio();
            } else {
              this.rightKeepRatio();
            }
            this.bottomKeepRatio();
            this.reCalcCropperCords();
          }if (this.area.resizingL) {
            if (this.area.resizingT) {
              this.topKeepRatio();
            } else {
              this.bottomKeepRatio();
            }
            this.leftKeepRatio();
            this.reCalcCropperCords();
          }if (this.area.resizingR) {
            if (this.area.resizingT) {
              this.topKeepRatio();
            } else {
              this.bottomKeepRatio();
            }
            this.rightKeepRatio();
            this.reCalcCropperCords();
          }
        }
        if (resizing && !this.shown) {
          this.show();
        }
        if (resizing) {
          (0, _utils.clearSelection)();
        }
      }
    }
  }, {
    key: 'leftKeepRatio',
    value: function leftKeepRatio() {
      var newW = this.area.rect.clientHeight * this.placedRatio;
      var suggLeft = this.area.el.documentOffsetLeft + (this.area.el.clientWidth - this.right - newW - 2);
      var absLeft = this.fixCropperLeft(suggLeft);
      this.setLeft(absLeft - this.area.el.documentOffsetLeft);
    }
  }, {
    key: 'topKeepRatio',
    value: function topKeepRatio() {
      var newH = this.area.rect.clientWidth / this.placedRatio;
      var absTop = this.fixCropperTop(this.area.el.documentOffsetTop + (this.area.el.clientHeight - this.bottom - newH - 2));
      this.setTop(absTop - this.area.el.documentOffsetTop);
    }
  }, {
    key: 'bottomKeepRatio',
    value: function bottomKeepRatio() {
      var newH = this.area.rect.clientWidth / this.placedRatio;
      var absBottom = this.fixCropperBottom(this.area.el.documentOffsetTop + this.top + newH + 2);
      this.setBottom(this.area.el.clientHeight + this.area.el.documentOffsetTop - absBottom);
    }
  }, {
    key: 'rightKeepRatio',
    value: function rightKeepRatio() {
      var newW = this.area.rect.clientHeight * this.placedRatio;
      var absRight = this.fixCropperRight(this.area.el.documentOffsetLeft + this.left + newW + 2);
      this.setRight(this.area.el.clientWidth + this.area.el.documentOffsetLeft - absRight);
    }
  }, {
    key: 'show',
    value: function show() {
      this.shown = true;
      this.area.rect.removeAttribute('hidden');
    }
  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      if (this.area.activated) {
        this.areaionCallback(this.area.rect.clientWidth > 0 && this.area.rect.clientHeight > 0);
      }
      this.area.moving = false;
      this.area.resizingT = false;
      this.area.resizingR = false;
      this.area.resizingB = false;
      this.area.resizingL = false;
      if (this.imagePlaced) {
        this.main.select.area.rect.style['background-image'] = 'url(' + this.placedData + ')';
      }
    }
  }, {
    key: 'close',
    value: function close() {
      if (this.imagePlaced) {
        this.finishPlacing();
      }
      this.area.activated = false;
      this.hide();
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.area.rect.setAttribute('hidden', 'true');
      this.shown = false;
    }
  }, {
    key: 'draw',
    value: function draw() {
      if (this.area.topl) {
        var ratio = this.canvas.clientWidth / this.canvas.getAttribute('width');
        this.setLeft(this.area.topl[0] * ratio);
        this.setTop(this.area.topl[1] * ratio);
        this.setRight(this.area.el.clientWidth - (this.area.bottoml[0] - this.area.topl[0]) * ratio);
        this.setBottom(this.area.el.clientHeight - (this.area.bottoml[1] - this.area.topl[1]) * ratio);
      }
    }

    /* fixers */

  }, {
    key: 'fixCropperLeft',
    value: function fixCropperLeft(left) {
      var newLeft = left;
      var absLeftMiddle = this.area.rect.documentOffsetLeft + this.area.rect.clientWidth;
      if (newLeft < this.area.el.documentOffsetLeft) {
        return this.area.el.documentOffsetLeft;
      } else if (newLeft > absLeftMiddle) {
        newLeft = absLeftMiddle;
        if (this.area.resizingL) {
          this.area.resizingL = false;
          this.area.resizingR = true;
        }
      }
      return newLeft;
    }
  }, {
    key: 'fixCropperRight',
    value: function fixCropperRight(right) {
      var newRight = right;
      var absRightLimit = this.area.el.documentOffsetLeft + this.area.el.clientWidth;
      if (newRight > absRightLimit) {
        return absRightLimit;
      } else if (newRight < this.area.rect.documentOffsetLeft) {
        newRight = this.area.rect.documentOffsetLeft + this.area.rect.clientWidth;
        if (this.area.resizingR) {
          this.area.resizingR = false;
          this.area.resizingL = true;
        }
      }
      return newRight;
    }
  }, {
    key: 'fixCropperTop',
    value: function fixCropperTop(top) {
      var newTop = top;
      var absTopMiddle = this.area.rect.documentOffsetTop + this.area.rect.clientHeight;
      if (newTop < this.area.el.documentOffsetTop) {
        return this.area.el.documentOffsetTop;
      } else if (newTop > absTopMiddle) {
        newTop = absTopMiddle;
        if (this.area.resizingT) {
          this.area.resizingT = false;
          this.area.resizingB = true;
        }
      }
      return newTop;
    }
  }, {
    key: 'fixCropperBottom',
    value: function fixCropperBottom(bottom) {
      var newBottom = bottom;
      var absBottomLimit = this.area.el.documentOffsetTop + this.area.el.clientHeight;
      if (newBottom > absBottomLimit) {
        return absBottomLimit;
      } else if (newBottom < this.area.rect.documentOffsetTop) {
        newBottom = this.area.rect.documentOffsetTop + this.area.rect.clientHeight;
        if (this.area.resizingB) {
          this.area.resizingB = false;
          this.area.resizingT = true;
        }
      }
      return newBottom;
    }
  }], [{
    key: 'code',
    value: function code() {
      return '<div class="ptro-crp-rect" hidden>' + '<div class="ptro-crp-l select-handler"></div><div class="ptro-crp-r select-handler"></div>' + '<div class="ptro-crp-t select-handler"></div><div class="ptro-crp-b select-handler"></div>' + '<div class="ptro-crp-tl select-handler"></div><div class="ptro-crp-tr select-handler"></div>' + '<div class="ptro-crp-bl select-handler"></div><div class="ptro-crp-br select-handler"></div>' + '</div>';
    }
  }]);

  return PainterroSelecter;
}();

exports.default = PainterroSelecter;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextTool = function () {
  function TextTool(main) {
    _classCallCheck(this, TextTool);

    this.ctx = main.ctx;
    this.el = main.toolContainer;
    this.main = main;
    this.input = this.el.querySelector('.ptro-text-tool-input');

    this.setFontSize(main.params.defaultFontSize);
    this.setFont(TextTool.getFonts()[0].value);
  }

  _createClass(TextTool, [{
    key: 'getFont',
    value: function getFont() {
      return this.font;
    }
  }, {
    key: 'setFont',
    value: function setFont(font) {
      this.font = font;
      this.input.style['font-family'] = font;
      if (this.active) {
        this.input.focus();
      }
      this.reLimit();
    }
  }, {
    key: 'setFontSize',
    value: function setFontSize(size) {
      this.fontSize = size;
      this.input.style['font-size'] = size + 'px';
      // if (this.active) {
      //   this.input.focus();
      // }
      this.reLimit();
    }
  }, {
    key: 'setFontColor',
    value: function setFontColor(color) {
      this.color = color;
      this.input.style.color = color;
    }
  }, {
    key: 'reLimit',
    value: function reLimit() {
      this.input.style.right = 'auto';
      if (this.input.documentOffsetLeft + this.input.clientWidth > this.el.documentOffsetLeft + this.el.clientWidth) {
        this.input.style.right = '0';
      } else {
        this.input.style.right = 'auto';
      }

      this.input.style.bottom = 'auto';
      if (this.input.documentOffsetTop + this.input.clientHeight > this.el.documentOffsetTop + this.el.clientHeight) {
        this.input.style.bottom = '0';
      } else {
        this.input.style.bottom = 'auto';
      }
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var _this = this;

      var mainClass = event.target.classList[0];
      if (mainClass === 'ptro-crp-el') {
        if (!this.active) {
          this.input.innerHTML = '<br>';
          this.pendingClear = true;
        }
        this.active = true;
        this.crd = [event.clientX - this.el.documentOffsetLeft + this.main.wrapper.scrollLeft, event.clientY - this.el.documentOffsetTop + this.main.wrapper.scrollTop];
        var scale = this.main.getScale();
        this.scaledCord = [this.crd[0] * scale, this.crd[1] * scale];
        this.input.style.left = this.crd[0] + 'px';
        this.input.style.top = this.crd[1] + 'px';
        this.input.style.display = 'inline';
        this.input.focus();
        this.reLimit();
        this.input.onkeydown = function (e) {
          if (e.keyCode === 13) {
            e.preventDefault();
          }
          _this.reLimit();
          if (_this.pendingClear) {
            _this.input.innerText = _this.input.innerText.slice(1);
            _this.pendingClear = false;
          }
        };
        event.preventDefault();
      }
    }
  }, {
    key: 'apply',
    value: function apply() {
      this.ctx.fillStyle = this.color;
      this.ctx.textAlign = 'left';
      this.ctx.font = this.fontSize * this.main.getScale() + 'px ' + this.font;
      this.ctx.fillText(this.input.innerText, this.scaledCord[0] + 2, this.scaledCord[1] + this.input.clientHeight * 0.8 * this.main.getScale());
      this.active = false;
      this.input.style.display = 'none';
      this.main.worklog.captureState();
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.active = false;
      this.input.style.display = 'none';
    }
  }], [{
    key: 'getFonts',
    value: function getFonts() {
      var fonts = ['Arial, Helvetica, sans-serif', '"Arial Black", Gadget, sans-serif', '"Comic Sans MS", cursive, sans-serif', 'Impact, Charcoal, sans-serif', '"Lucida Sans Unicode", "Lucida Grande", sans-serif', 'Tahoma, Geneva, sans-serif', '"Trebuchet MS", Helvetica, sans-serif', 'Verdana, Geneva, sans-serif', '"Courier New", Courier, monospace', '"Lucida Console", Monaco, monospace'];

      var res = [];
      fonts.forEach(function (f) {
        res.push({
          value: f,
          name: f.split(',')[0].replace(/"/g, '')
        });
      });
      return res;
    }
  }, {
    key: 'code',
    value: function code() {
      return '<span contenteditable="true" class="ptro-text-tool-input" style="display:none"></span>';
    }
  }]);

  return TextTool;
}();

exports.default = TextTool;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WorkLog = function () {
  function WorkLog(main, changedHandler) {
    _classCallCheck(this, WorkLog);

    this.main = main;
    this.current = null;
    this.changedHandler = changedHandler;
    this.empty = true;
  }

  _createClass(WorkLog, [{
    key: "changed",
    value: function changed() {
      this.changedHandler();
      this.empty = false;
    }
  }, {
    key: "captureState",
    value: function captureState(initial) {
      var state = {
        sizew: this.main.size.w,
        sizeh: this.main.size.h,
        data: this.main.canvas.toDataURL()
      };
      if (this.current === null) {
        state.prev = null;
      } else {
        state.prev = this.current;
        this.current.next = state;
      }
      state.next = null;
      this.current = state;
      if (initial !== true) {
        this.changed();
      }
    }
  }, {
    key: "reCaptureState",
    value: function reCaptureState() {
      if (this.current.prev !== null) {
        this.current = this.current.prev;
      }
      this.captureState();
    }
  }, {
    key: "applyState",
    value: function applyState(state) {
      var _this = this;

      var img = new Image();
      img.onload = function () {
        _this.main.resize(state.sizew, state.sizeh);
        _this.main.ctx.drawImage(img, 0, 0);
        _this.main.adjustSizeFull();
        _this.main.select.hide();
      };
      img.src = state.data;
    }
  }, {
    key: "undoState",
    value: function undoState() {
      if (this.current.prev !== null) {
        this.current = this.current.prev;
        this.applyState(this.current);
        this.changed();
      }
    }
  }, {
    key: "redoState",
    value: function redoState() {
      if (this.current.next !== null) {
        this.current = this.current.next;
        this.applyState(this.current);
        this.changed();
      }
    }
  }]);

  return WorkLog;
}();

exports.default = WorkLog;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZoomHelper = function () {
  function ZoomHelper(main) {
    _classCallCheck(this, ZoomHelper);

    this.main = main;
    this.zomer = main.wrapper.querySelector('.ptro-zoomer');
    this.zomerCtx = this.zomer.getContext('2d');
    this.canvas = this.main.canvas;
    this.ctx = this.main.ctx;
    this.wrapper = this.main.wrapper;

    this.gridColor = this.zomerCtx.createImageData(1, 1);
    this.gridColor.data[0] = 255;
    this.gridColor.data[1] = 255;
    this.gridColor.data[2] = 255;
    this.gridColor.data[3] = 255;

    this.gridColorRed = this.zomerCtx.createImageData(1, 1);
    this.gridColorRed.data[0] = 255;
    this.gridColorRed.data[1] = 0;
    this.gridColorRed.data[2] = 0;
    this.gridColorRed.data[3] = 255;

    this.captW = 7;
    this.middle = Math.ceil(this.captW / 2) - 1;
    this.periodW = 8;

    this.fullW = this.captW * this.periodW;
    this.halfFullW = this.fullW / 2;
    this.zomer.setAttribute('width', this.fullW);
    this.zomer.setAttribute('height', this.fullW);
    this.cursor = this.wrapper.style.cursor;
  }

  _createClass(ZoomHelper, [{
    key: 'handleMouseMove',
    value: function handleMouseMove(e) {
      if (this.main.colorPicker.choosing && e.altKey) {
        if (!this.shown) {
          this.shown = true;
          this.zomer.style.display = 'block';
          this.cursor = this.wrapper.style.cursor;
          this.wrapper.style.cursor = 'none';
        }
        var scale = this.main.getScale();

        var x = (e.clientX - this.canvas.documentOffsetLeft) * scale;
        x = x < 1 ? 1 : x;
        x = x > this.main.size.w - 1 ? this.main.size.w - 1 : x;
        var y = (e.clientY - this.canvas.documentOffsetTop) * scale;
        y = y < 1 ? 1 : y;
        y = y > this.main.size.h - 1 ? this.main.size.h - 1 : y;

        var captW = this.captW;
        var periodW = this.periodW;

        for (var i = 0; i < captW; i += 1) {
          for (var j = 0; j < captW; j += 1) {
            var d = this.ctx.getImageData(x + i - this.middle, y + j - this.middle, 1, 1);
            for (var ii = 0; ii < periodW; ii += 1) {
              for (var jj = 0; jj < periodW; jj += 1) {
                if (ii === periodW - 1 || jj === periodW - 1) {
                  if (i === this.middle && j === this.middle || i === this.middle && j === this.middle - 1 && jj === periodW - 1 || i === this.middle - 1 && j === this.middle && ii === periodW - 1) {
                    this.zomerCtx.putImageData(this.gridColorRed, i * periodW + ii, j * periodW + jj);
                  } else {
                    this.zomerCtx.putImageData(this.gridColor, i * periodW + ii, j * periodW + jj);
                  }
                } else {
                  this.zomerCtx.putImageData(d, i * periodW + ii, j * periodW + jj);
                }
              }
            }
          }
        }
        this.zomer.style.left = e.clientX - this.wrapper.documentOffsetLeft - this.halfFullW + 'px';
        this.zomer.style.top = e.clientY - this.wrapper.documentOffsetTop - this.halfFullW + 'px';
      } else if (this.shown) {
        this.zomer.style.display = 'none';
        this.wrapper.style.cursor = this.cursor;
        this.shown = false;
      }
    }
  }], [{
    key: 'html',
    value: function html() {
      return '<canvas class="ptro-zoomer" width="" height="0"></canvas>';
    }
  }]);

  return ZoomHelper;
}();

exports.default = ZoomHelper;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(18);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!./bar-styles.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!./bar-styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(19);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./iconfont.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./iconfont.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(20);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(15);

__webpack_require__(13);

__webpack_require__(14);

var _selecter = __webpack_require__(9);

var _selecter2 = _interopRequireDefault(_selecter);

var _worklog = __webpack_require__(11);

var _worklog2 = _interopRequireDefault(_worklog);

var _utils = __webpack_require__(1);

var _primitive = __webpack_require__(7);

var _primitive2 = _interopRequireDefault(_primitive);

var _colorPicker = __webpack_require__(4);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _params = __webpack_require__(6);

var _translation = __webpack_require__(0);

var _zoomHelper = __webpack_require__(12);

var _zoomHelper2 = _interopRequireDefault(_zoomHelper);

var _text = __webpack_require__(10);

var _text2 = _interopRequireDefault(_text);

var _resizer = __webpack_require__(8);

var _resizer2 = _interopRequireDefault(_resizer);

var _inserter = __webpack_require__(5);

var _inserter2 = _interopRequireDefault(_inserter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PainterroProc = function () {
  function PainterroProc(params) {
    var _this = this;

    _classCallCheck(this, PainterroProc);

    (0, _utils.addDocumentObjectHelpers)();
    this.params = (0, _params.setDefaults)(params);

    this.tools = [{
      name: 'select',
      activate: function activate() {
        _this.toolContainer.style.cursor = 'crosshair';
        _this.select.activate();
        _this.select.draw();
      },
      close: function close() {
        _this.select.close();
        _this.toolContainer.style.cursor = 'auto';
      },
      eventListner: function eventListner() {
        return _this.select;
      }
    }, {
      name: 'crop',
      activate: function activate() {
        _this.select.doCrop();
        _this.closeActiveTool();
      }
    }, {
      name: 'pixelize',
      activate: function activate() {
        _this.select.doPixelize();
        _this.closeActiveTool();
      }
    }, {
      name: 'line',
      controls: [{
        type: 'color',
        title: 'lineColor',
        target: 'line',
        titleFull: 'lineColorFull',
        action: function action() {
          _this.colorPicker.open(_this.colorWidgetState.line);
        }
      }, {
        type: 'int',
        title: 'lineWidth',
        titleFull: 'lineWidthFull',
        target: 'lineWidth',
        min: 1,
        max: 99,
        action: function action() {
          var width = document.getElementById(_this.activeTool.controls[1].id);
          _this.primitiveTool.setLineWidth(width.value);
          (0, _params.setParam)('defaultLineWidth', width.value);
        },
        getValue: function getValue() {
          return _this.primitiveTool.lineWidth;
        }
      }],
      activate: function activate() {
        _this.toolContainer.style.cursor = 'crosshair';
        _this.primitiveTool.activate('line');
      },
      eventListner: function eventListner() {
        return _this.primitiveTool;
      }
    }, {
      name: 'rect',
      controls: [{
        type: 'color',
        title: 'lineColor',
        titleFull: 'lineColorFull',
        target: 'line',
        action: function action() {
          _this.colorPicker.open(_this.colorWidgetState.line);
        }
      }, {
        type: 'color',
        title: 'fillColor',
        titleFull: 'fillColorFull',
        target: 'fill',
        action: function action() {
          _this.colorPicker.open(_this.colorWidgetState.fill);
        }
      }, {
        type: 'int',
        title: 'lineWidth',
        titleFull: 'lineWidthFull',
        target: 'lineWidth',
        min: 1,
        max: 99,
        action: function action() {
          var width = document.getElementById(_this.activeTool.controls[2].id).value;
          _this.primitiveTool.setLineWidth(width);
          (0, _params.setParam)('defaultLineWidth', width.value);
        },
        getValue: function getValue() {
          return _this.primitiveTool.lineWidth;
        }
      }],
      activate: function activate() {
        _this.toolContainer.style.cursor = 'crosshair';
        _this.primitiveTool.activate('rect');
      },
      eventListner: function eventListner() {
        return _this.primitiveTool;
      }
    }, {
      name: 'ellipse',
      controls: [{
        type: 'color',
        title: 'lineColor',
        titleFull: 'lineColorFull',
        target: 'line',
        action: function action() {
          _this.colorPicker.open(_this.colorWidgetState.line);
        }
      }, {
        type: 'color',
        title: 'fillColor',
        titleFull: 'fillColorFull',
        target: 'fill',
        action: function action() {
          _this.colorPicker.open(_this.colorWidgetState.fill);
        }
      }, {
        type: 'int',
        title: 'lineWidth',
        titleFull: 'lineWidthFull',
        target: 'lineWidth',
        min: 1,
        max: 99,
        action: function action() {
          var width = document.getElementById(_this.activeTool.controls[2].id).value;
          _this.primitiveTool.setLineWidth(width);
          (0, _params.setParam)('defaultLineWidth', width.value);
        },
        getValue: function getValue() {
          return _this.primitiveTool.lineWidth;
        }
      }],
      activate: function activate() {
        _this.toolContainer.style.cursor = 'crosshair';
        _this.primitiveTool.activate('ellipse');
      },
      eventListner: function eventListner() {
        return _this.primitiveTool;
      }
    }, {
      name: 'brush',
      controls: [{
        type: 'color',
        title: 'lineColor',
        target: 'line',
        titleFull: 'lineColorFull',
        action: function action() {
          _this.colorPicker.open(_this.colorWidgetState.line);
        }
      }, {
        type: 'int',
        title: 'lineWidth',
        titleFull: 'lineWidthFull',
        target: 'lineWidth',
        min: 1,
        max: 99,
        action: function action() {
          var width = document.getElementById(_this.activeTool.controls[1].id);
          _this.primitiveTool.setLineWidth(width.value);
          (0, _params.setParam)('defaultLineWidth', width.value);
        },
        getValue: function getValue() {
          return _this.primitiveTool.lineWidth;
        }
      }],
      activate: function activate() {
        _this.toolContainer.style.cursor = 'crosshair';
        _this.primitiveTool.activate('brush');
      },
      eventListner: function eventListner() {
        return _this.primitiveTool;
      }
    }, {
      name: 'text',
      controls: [{
        type: 'color',
        title: 'textColor',
        titleFull: 'textColorFull',
        target: 'line',
        action: function action() {
          _this.colorPicker.open(_this.colorWidgetState.line, function (c) {
            _this.textTool.setFontColor(c.alphaColor);
          });
        }
      }, {
        type: 'int',
        title: 'fontSize',
        titleFull: 'fontSizeFull',
        target: 'fontSize',
        min: 1,
        max: 200,
        action: function action() {
          var width = document.getElementById(_this.activeTool.controls[1].id).value;
          _this.textTool.setFontSize(width);
          (0, _params.setParam)('defaultFontSize', width.value);
        },
        getValue: function getValue() {
          return _this.textTool.fontSize;
        }
      }, {
        type: 'dropdown',
        title: 'fontName',
        titleFull: 'fontNameFull',
        target: 'fontName',
        action: function action() {
          var dropdown = document.getElementById(_this.activeTool.controls[2].id);
          var font = dropdown.value;
          _this.textTool.setFont(font);
        },
        getValue: function getValue() {
          return _this.textTool.getFont();
        },
        getAvilableValues: function getAvilableValues() {
          return _text2.default.getFonts();
        }
      }, {
        name: (0, _translation.tr)('apply'),
        type: 'btn',
        action: function action() {
          _this.textTool.apply();
          _this.closeActiveTool();
        }
      }, {
        name: (0, _translation.tr)('cancel'),
        type: 'btn',
        action: function action() {
          _this.textTool.cancel();
          _this.closeActiveTool();
        }
      }],
      activate: function activate() {
        _this.textTool.setFontColor(_this.colorWidgetState.line.alphaColor);
        _this.toolContainer.style.cursor = 'crosshair';
      },
      close: function close() {
        _this.textTool.cancel();
      },
      eventListner: function eventListner() {
        return _this.textTool;
      }
    }, {
      name: 'rotate',
      activate: function activate() {
        var tmpData = _this.canvas.toDataURL();
        var w = _this.size.w;
        var h = _this.size.h;
        _this.resize(h, w);

        _this.ctx.save();
        _this.ctx.translate(h / 2, w / 2);
        _this.ctx.rotate(90 * Math.PI / 180);
        var img = new Image();
        img.onload = function () {
          _this.ctx.drawImage(img, -w / 2, -h / 2);
          _this.adjustSizeFull();
          _this.ctx.restore();
          _this.worklog.captureState();
          _this.closeActiveTool();
        };
        img.src = tmpData;
      }
    }, {
      name: 'resize',
      activate: function activate() {
        _this.resizer.open();
      },
      close: function close() {
        _this.resizer.close();
      }
    }, {
      name: 'save',
      right: true,
      activate: function activate() {
        _this.save();
        _this.closeActiveTool();
      }
    }, {
      name: 'open',
      right: true,
      activate: function activate() {
        _this.closeActiveTool();
        var input = document.getElementById('ptro-file-input');
        input.click();
        input.onchange = function (event) {
          var files = event.target.files || event.dataTransfer.files;
          if (!files.length) {
            return;
          }
          _this.openFile(files[0]);
          input.value = ''; // to allow reopen
        };
      }
    }, {
      name: 'close',
      right: true,
      activate: function activate() {
        _this.closeActiveTool();
        _this.hide();
      }
    }];

    this.toolByName = {};
    this.tools.forEach(function (t) {
      _this.toolByName[t.name] = t;
    });
    this.activeTool = undefined;
    this.zoom = false;
    this.ratioRelation = undefined;
    this.id = this.params.id;
    this.saving = false;

    if (this.id === undefined) {
      this.id = (0, _utils.genId)();
      this.holderId = (0, _utils.genId)();
      this.holderEl = document.createElement('div');
      this.holderEl.id = this.holderId;
      this.holderEl.className = 'ptro-holder-wrapper';
      document.body.appendChild(this.holderEl);
      this.holderEl.innerHTML = '<div id=\'' + this.id + '\' class="ptro-holder"></div>';
      this.baseEl = document.getElementById(this.id);
    } else {
      this.baseEl = document.getElementById(this.id);
      this.holderEl = null;
    }
    var bar = '';
    var rightBar = '';
    this.tools.filter(function (t) {
      return _this.params.hiddenTools.indexOf(t.name) === -1;
    }).forEach(function (b) {
      var id = (0, _utils.genId)();
      b.buttonId = id;
      var btn = '<button class="ptro-icon-btn ptro-color-control" title="' + (0, _translation.tr)('tools.' + b.name) + '" ' + ('id="' + id + '" >') + ('<i class="ptro-icon ptro-icon-' + b.name + '"></i></button>');
      if (b.right) {
        rightBar += btn;
      } else {
        bar += btn;
      }
    });

    this.inserter = new _inserter2.default();

    var cropper = '<div class="ptro-crp-el">' + ('' + _selecter2.default.code() + _text2.default.code() + '</div>');

    this.loadedName = '';
    this.doc = document;
    this.wrapper = this.doc.createElement('div');
    this.wrapper.id = this.id + '-wrapper';
    this.wrapper.className = 'ptro-wrapper';
    this.wrapper.innerHTML = '<canvas id="' + this.id + '-canvas"></canvas>' + (cropper + _colorPicker2.default.html() + _zoomHelper2.default.html() + _resizer2.default.html() + this.inserter.html());
    this.baseEl.appendChild(this.wrapper);

    this.bar = this.doc.createElement('div');
    this.bar.id = this.id + '-bar';
    this.bar.className = 'ptro-bar ptro-color-main';
    this.bar.innerHTML = '<span>' + bar + '</span>' + '<span class="tool-controls"></span>' + ('<span class="ptro-bar-right">' + rightBar + '</span>') + '<span class="ptro-info"></span>' + '<input id="ptro-file-input" type="file" style="display: none;" accept="image/x-png,image/gif,image/jpeg" />';

    this.baseEl.appendChild(this.bar);
    var style = this.doc.createElement('style');
    style.type = 'text/css';
    style.innerHTML = this.params.styles;
    this.baseEl.appendChild(style);

    // this.baseEl.innerHTML = '<iframe class="ptro-iframe"></iframe>';
    // this.iframe = this.baseEl.getElementsByTagName('iframe')[0];
    // this.doc = this.iframe.contentDocument || this.iframe.contentWindow.document;
    // this.doc.body.innerHTML = html;

    this.saveBtn = this.doc.getElementById(this.toolByName.save.buttonId);
    if (this.saveBtn) {
      this.saveBtn.setAttribute('disabled', 'true');
    }
    this.body = this.doc.body;
    this.info = this.doc.querySelector('#' + this.id + '-bar .ptro-info');
    this.canvas = this.doc.querySelector('#' + this.id + '-canvas');
    this.ctx = this.canvas.getContext('2d');
    this.toolControls = this.doc.querySelector('#' + this.id + '-bar .tool-controls');
    this.toolContainer = this.doc.querySelector('#' + this.id + '-wrapper .ptro-crp-el');
    this.zoomHelper = new _zoomHelper2.default(this);
    this.select = new _selecter2.default(this, function (notEmpty) {
      [_this.toolByName.crop, _this.toolByName.pixelize].forEach(function (c) {
        if (notEmpty) {
          _this.doc.getElementById(c.buttonId).removeAttribute('disabled');
        } else {
          _this.doc.getElementById(c.buttonId).setAttribute('disabled', 'true');
        }
      });
    });
    this.resizer = new _resizer2.default(this);
    this.primitiveTool = new _primitive2.default(this);
    this.primitiveTool.setLineWidth(this.params.defaultLineWidth);
    this.primitiveTool.setPixelSize(this.params.defaultPixelSize);
    this.worklog = new _worklog2.default(this, function () {
      if (_this.saveBtn) {
        _this.saveBtn.removeAttribute('disabled');
      }
    });
    this.inserter.init(this);
    this.textTool = new _text2.default(this);
    this.colorPicker = new _colorPicker2.default(this, function (widgetState) {
      _this.colorWidgetState[widgetState.target] = widgetState;
      _this.doc.querySelector('#' + _this.id + ' .color-diwget-btn[data-id=\'' + widgetState.target + '\']').style['background-color'] = widgetState.alphaColor;
      if (widgetState.target === 'line') {
        (0, _params.setParam)('activeColor', widgetState.palleteColor);
        (0, _params.setParam)('activeColorAlpha', widgetState.alpha);
      } else if (widgetState.target === 'fill') {
        (0, _params.setParam)('activeFillColor', widgetState.palleteColor);
        (0, _params.setParam)('activeFillColorAlpha', widgetState.alpha);
      }
    });
    this.colorWidgetState = {
      line: {
        target: 'line',
        palleteColor: this.params.activeColor,
        alpha: this.params.activeColorAlpha,
        alphaColor: this.params.activeAlphaColor
      },
      fill: {
        target: 'fill',
        palleteColor: this.params.activeFillColor,
        alpha: this.params.activeFillColorAlpha,
        alphaColor: this.params.activeFillAlphaColor
      }
    };

    this.tools.filter(function (t) {
      return _this.params.hiddenTools.indexOf(t.name) === -1;
    }).forEach(function (b) {
      _this.getBtnEl(b).onclick = function () {
        if (b === _this.toolByName.select && _this.activeTool === b) {
          return;
        }
        var currentActive = _this.activeTool;
        _this.closeActiveTool(true);
        if (currentActive !== b) {
          _this.setActiveTool(b);
        } else {
          _this.setActiveTool(_this.toolByName.select);
        }
      };
    });

    this.setActiveTool(this.toolByName.select);

    this.imageSaver = {
      /**
       * Returns image as base64 data url
       * @param {string} type - type of data url, default image/png
       * @param {string} quality - number from 0 to 1, works for `image/jpeg` or `image/webp`
       */
      asDataURL: function asDataURL(type, quality) {
        var realType = type;
        if (realType === undefined) {
          realType = 'image/png';
        }
        return _this.getAsUri(realType, quality);
      },
      asBlob: function asBlob(type, quality) {
        var realType = type;
        if (realType === undefined) {
          realType = 'image/png';
        }
        var uri = _this.getAsUri(realType, quality);
        var byteString = atob(uri.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i += 1) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], {
          type: realType
        });
      },
      suggestedFileName: function suggestedFileName(type) {
        var realType = type;
        if (realType === undefined) {
          realType = 'png';
        }
        return (_this.loadedName || 'image-' + (0, _utils.genId)()) + '.' + realType;
      }
    };

    this.initEventHandlers();
    this.clear();
    this.hide();
  }

  _createClass(PainterroProc, [{
    key: 'getAsUri',
    value: function getAsUri(type, quality) {
      var realQuality = quality;
      if (realQuality === undefined) {
        realQuality = 0.92;
      }
      return this.canvas.toDataURL(type, realQuality);
    }
  }, {
    key: 'getBtnEl',
    value: function getBtnEl(b) {
      return this.doc.getElementById(b.buttonId);
    }
  }, {
    key: 'save',
    value: function save() {
      var _this2 = this;

      if (this.saving) {
        return this;
      }
      this.saving = true;
      var btn = this.doc.getElementById(this.toolByName.save.buttonId);
      var icon = this.doc.querySelector('#' + this.toolByName.save.buttonId + ' > i');
      if (btn) {
        btn.setAttribute('disabled', 'true');
      }
      if (icon) {
        icon.className = 'ptro-icon ptro-icon-loading ptro-spinning';
      }

      if (this.params.saveHandler !== undefined) {
        this.params.saveHandler(this.imageSaver, function (hide) {
          if (hide === true) {
            _this2.hide();
          }
          if (icon) {
            icon.className = 'ptro-icon ptro-icon-save';
          }
          _this2.saving = false;
        });
      } else {
        console.error('No saveHandler defined, please check documentation');
        if (icon) {
          icon.className = 'ptro-icon ptro-icon-save';
        }
        this.saving = false;
      }
      return this;
    }
  }, {
    key: 'closeActiveTool',
    value: function closeActiveTool(doNotSelect) {
      if (this.activeTool !== undefined) {
        if (this.activeTool.close !== undefined) {
          this.activeTool.close();
        }
        this.toolControls.innerHTML = '';
        this.getBtnEl(this.activeTool).className = this.getBtnEl(this.activeTool).className.replace(' ptro-color-active-control', '');
        this.activeTool = undefined;
      }
      if (doNotSelect !== true) {
        this.setActiveTool(this.toolByName.select);
      }
    }
  }, {
    key: 'handleToolEvent',
    value: function handleToolEvent(eventHandler, event) {
      if (this.activeTool && this.activeTool.eventListner) {
        var listner = this.activeTool.eventListner();
        if (listner[eventHandler]) {
          listner[eventHandler](event);
        }
      }
    }
  }, {
    key: 'initEventHandlers',
    value: function initEventHandlers() {
      var _this3 = this;

      this.documentHandlers = {
        mousedown: function mousedown(e) {
          if (_this3.shown) {
            if (_this3.worklog.empty) {
              _this3.clearBackground(); // clear initText
            }
            if (_this3.colorPicker.handleMouseDown(e) !== true) {
              _this3.handleToolEvent('handleMouseDown', e);
            }
          }
        },
        mousemove: function mousemove(e) {
          if (_this3.shown) {
            _this3.handleToolEvent('handleMouseMove', e);
            _this3.colorPicker.handleMouseMove(e);
            _this3.zoomHelper.handleMouseMove(e);
          }
        },
        mouseup: function mouseup(e) {
          if (_this3.shown) {
            _this3.handleToolEvent('handleMouseUp', e);
            _this3.colorPicker.handleMouseUp(e);
          }
        },
        mousewheel: function mousewheel(e) {
          if (_this3.shown) {
            if (e.ctrlKey) {
              _this3.zoom = e.wheelDelta > 0;
              _this3.adjustSizeFull();
              e.preventDefault();
            }
          }
        },
        keydown: function keydown(e) {
          if (_this3.shown) {
            var evt = window.event ? event : e;
            _this3.handleToolEvent('handleKeyDown', evt);
            if (evt.keyCode === _utils.KEYS.y && evt.ctrlKey || evt.keyCode === _utils.KEYS.z && evt.ctrlKey && evt.shiftKey) {
              _this3.worklog.redoState();
            } else if (evt.keyCode === _utils.KEYS.z && evt.ctrlKey) {
              _this3.worklog.undoState();
            }

            if (_this3.saveBtn) {
              if (evt.keyCode === _utils.KEYS.s && evt.ctrlKey) {
                _this3.save();
                evt.preventDefault();
              }
            }
          }
        },
        paste: function paste(event) {
          if (_this3.shown) {
            var items = (event.clipboardData || event.originalEvent.clipboardData).items;
            Object.keys(items).forEach(function (k) {
              var item = items[k];
              if (item.kind === 'file' && item.type.split('/')[0] === 'image') {
                _this3.openFile(item.getAsFile());
              } else if (item.kind === 'string') {
                var txt = '';
                if (window.clipboardData && window.clipboardData.getData) {
                  // IE
                  txt = window.clipboardData.getData('Text');
                } else if (event.clipboardData && event.clipboardData.getData) {
                  txt = event.clipboardData.getData('text/plain');
                }
                if (txt.startsWith(_this3.inserter.CLIP_DATA_MARKER)) {
                  _this3.loadImage(txt.slice(_this3.inserter.CLIP_DATA_MARKER.length));
                }
              }
            });
          }
        },
        dragover: function dragover(event) {
          if (_this3.shown) {
            var mainClass = event.target.classList[0];
            if (mainClass === 'ptro-crp-el' || mainClass === 'ptro-bar') {
              _this3.bar.className = 'ptro-bar ptro-color-main ptro-bar-dragover';
            }
            event.preventDefault();
          }
        },
        dragleave: function dragleave() {
          if (_this3.shown) {
            _this3.bar.className = 'ptro-bar ptro-color-main';
          }
        },
        drop: function drop(event) {
          if (_this3.shown) {
            _this3.bar.className = 'ptro-bar ptro-color-main';
            event.preventDefault();
            _this3.openFile(event.dataTransfer.files[0]);
          }
        }
      };

      this.windowHandlers = {
        resize: function resize() {
          if (_this3.shown) {
            _this3.adjustSizeFull();
            _this3.syncToolElement();
          }
        }
      };

      Object.keys(this.documentHandlers).forEach(function (key) {
        _this3.doc.addEventListener(key, _this3.documentHandlers[key]);
      });

      Object.keys(this.windowHandlers).forEach(function (key) {
        window.addEventListener(key, _this3.windowHandlers[key]);
      });
    }
  }, {
    key: 'fitImage',
    value: function fitImage(img) {
      this.resize(img.naturalWidth, img.naturalHeight);
      this.ctx.drawImage(img, 0, 0);
      this.adjustSizeFull();
      this.worklog.captureState();
    }
  }, {
    key: 'loadImage',
    value: function loadImage(source) {
      this.inserter.handleOpen(source);
    }
  }, {
    key: 'show',
    value: function show(openImage) {
      this.shown = true;
      this.baseEl.removeAttribute('hidden');
      if (this.holderEl) {
        this.holderEl.removeAttribute('hidden');
      }
      if (typeof openImage === 'string') {
        this.loadedName = (0, _utils.trim)((openImage.substring(openImage.lastIndexOf('/') + 1) || '').replace(/\..+$/, ''));

        this.loadImage(openImage);
      } else if (openImage !== false) {
        this.clear();
      }
      return this;
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.shown = false;
      this.baseEl.setAttribute('hidden', '');
      if (this.holderEl) {
        this.holderEl.setAttribute('hidden', '');
      }
      return this;
    }
  }, {
    key: 'openFile',
    value: function openFile(f) {
      this.loadedName = (0, _utils.trim)((f.name || '').replace(/\..+$/, ''));
      this.loadImage(URL.createObjectURL(f));
    }
  }, {
    key: 'getScale',
    value: function getScale() {
      return this.canvas.getAttribute('width') / this.canvas.offsetWidth;
    }
  }, {
    key: 'adjustSizeFull',
    value: function adjustSizeFull() {
      if (this.size.w > this.wrapper.documentClientWidth || this.size.h > this.wrapper.documentClientHeight) {
        var ratio = this.wrapper.documentClientWidth / this.wrapper.documentClientHeight;

        if (this.zoom === false) {
          var newRelation = ratio < this.size.ratio;
          if (newRelation !== this.ratioRelation) {
            this.ratioRelation = newRelation;
            if (newRelation) {
              this.canvas.style.width = '100%';
              this.canvas.style.height = 'auto';
            } else {
              this.canvas.style.width = 'auto';
              this.canvas.style.height = '100%';
            }
          }
          this.wrapper.style.overflow = 'hidden';
          this.wrapper.className = 'ptro-wrapper ptro-v-aligned';
        } else {
          this.wrapper.style.overflow = 'scroll';
          this.canvas.style.width = 'auto';
          this.canvas.style.height = 'auto';
          this.ratioRelation = 0;
          this.wrapper.className = 'ptro-wrapper';
        }
      } else {
        this.wrapper.style.overflow = 'hidden';
        this.canvas.style.width = 'auto';
        this.canvas.style.height = 'auto';
        this.wrapper.className = 'ptro-wrapper ptro-v-aligned';
        this.ratioRelation = 0;
      }
      this.syncToolElement();
      this.select.draw();
    }
  }, {
    key: 'resize',
    value: function resize(x, y) {
      this.info.innerHTML = x + ' x ' + y;
      this.size = {
        w: x,
        h: y,
        ratio: x / y
      };
      this.canvas.setAttribute('width', this.size.w);
      this.canvas.setAttribute('height', this.size.h);
    }
  }, {
    key: 'syncToolElement',
    value: function syncToolElement() {
      var w = Math.round(this.canvas.documentClientWidth);
      var l = this.canvas.offsetLeft;
      var h = Math.round(this.canvas.documentClientHeight);
      var t = this.canvas.offsetTop;
      this.toolContainer.style.left = l + 'px';
      this.toolContainer.style.width = w + 'px';
      this.toolContainer.style.top = t + 'px';
      this.toolContainer.style.height = h + 'px';
    }
  }, {
    key: 'clear',
    value: function clear() {
      var w = this.params.defaultSize.width === 'fill' ? this.wrapper.clientWidth : this.params.defaultSize.width;
      var h = this.params.defaultSize.height === 'fill' ? this.wrapper.clientHeight : this.params.defaultSize.height;
      this.resize(w, h);
      this.clearBackground();
      this.worklog.captureState(true);
      this.syncToolElement();
      this.adjustSizeFull();

      if (this.params.initText && this.worklog.empty) {
        this.ctx.fillStyle = this.params.initTextColor;
        this.ctx.textAlign = 'center';
        this.ctx.font = this.params.initTextStyle;
        this.ctx.fillText(this.params.initText, this.size.w / 2, this.size.h / 2);
      }
    }
  }, {
    key: 'clearBackground',
    value: function clearBackground() {
      this.ctx.beginPath();
      this.ctx.rect(0, 0, this.size.w, this.size.h);
      this.ctx.fillStyle = this.params.backgroundFillColor;
      this.ctx.fill();
    }
  }, {
    key: 'setActiveTool',
    value: function setActiveTool(b) {
      var _this4 = this;

      this.activeTool = b;
      this.getBtnEl(b).className += ' ptro-color-active-control';
      var ctrls = '';
      (b.controls || []).forEach(function (ctl) {
        ctl.id = (0, _utils.genId)();
        if (ctl.title) {
          ctrls += '<span class="ptro-tool-ctl-name" title="' + (0, _translation.tr)(ctl.titleFull) + '">' + (0, _translation.tr)(ctl.title) + '</span>';
        }
        if (ctl.type === 'btn') {
          ctrls += '<button ' + (ctl.hint ? 'title="' + (0, _translation.tr)(ctl.hint) + '"' : '') + ' class="ptro-color-control ' + (ctl.icon ? 'ptro-icon-btn' : 'ptro-named-btn') + '" ' + ('id=' + ctl.id + '>' + (ctl.icon ? '<i class="ptro-icon ptro-icon-' + ctl.icon + '"></i>' : '')) + ('<p>' + (ctl.name || '') + '</p></button>');
        } else if (ctl.type === 'color') {
          ctrls += '<button id=' + ctl.id + ' data-id=\'' + ctl.target + '\' ' + ('style="background-color: ' + _this4.colorWidgetState[ctl.target].alphaColor + '" ') + 'class="color-diwget-btn ptro-bordered-btn"></button>' + '<span class="ptro-btn-color-bg">' + '<span></span><span></span><span></span><span></span>' + '<span></span><span></span><span></span><span></span>' + '</span>' + '<span class="color-diwget-btn-substrate"></span>';
        } else if (ctl.type === 'int') {
          ctrls += '<input id=' + ctl.id + ' class="ptro-input" type="number" min="' + ctl.min + '" max="' + ctl.max + '" ' + ('data-id=\'' + ctl.target + '\'/>');
        } else if (ctl.type === 'dropdown') {
          var options = '';
          ctl.getAvilableValues().forEach(function (o) {
            options += '<option ' + (ctl.target === 'fontName' ? 'style=\'font-family:' + o.value + '\'' : '') + (' value=\'' + o.value + '\'>' + o.name + '</option>');
          });
          ctrls += '<select id=' + ctl.id + ' class="ptro-input" ' + ('data-id=\'' + ctl.target + '\'>' + options + '</select>');
        }
      });
      this.toolControls.innerHTML = ctrls;
      (b.controls || []).forEach(function (ctl) {
        if (ctl.type === 'int') {
          _this4.doc.getElementById(ctl.id).value = ctl.getValue();
          _this4.doc.getElementById(ctl.id).oninput = ctl.action;
        } else if (ctl.type === 'dropdown') {
          _this4.doc.getElementById(ctl.id).onchange = ctl.action;
        } else {
          _this4.doc.getElementById(ctl.id).onclick = ctl.action;
        }
      });
      b.activate();
    }
  }]);

  return PainterroProc;
}();

module.exports = function (params) {
  return new PainterroProc(params);
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".color-diwget-btn{height:32px;width:32px;cursor:pointer;z-index:201;position:absolute;top:4px}.color-diwget-btn-substrate{display:inline-block;width:32px}.ptro-bar .ptro-btn-color-bg{z-index:200;position:absolute;top:4px}.ptro-bar .ptro-btn-color-bg span{width:8px;background-color:#676767;display:block;height:8px;position:absolute}.ptro-bar .ptro-btn-color-bg span:first-of-type{left:0}.ptro-bar .ptro-btn-color-bg span:nth-of-type(2){left:8px;margin-top:8px}.ptro-bar .ptro-btn-color-bg span:nth-of-type(3){left:16px}.ptro-bar .ptro-btn-color-bg span:nth-of-type(4){left:24px;margin-top:8px}.ptro-bar .ptro-btn-color-bg span:nth-of-type(5){left:0;margin-top:16px}.ptro-bar .ptro-btn-color-bg span:nth-of-type(6){left:8px;margin-top:24px}.ptro-bar .ptro-btn-color-bg span:nth-of-type(7){left:16px;margin-top:16px}.ptro-bar .ptro-btn-color-bg span:nth-of-type(8){left:24px;margin-top:24px}.ptro-bar .ptro-tool-ctl-name{padding:0 2px 0 0;line-height:30px;margin-left:5px}.ptro-bar .ptro-input,.ptro-bar .ptro-tool-ctl-name{font-family:Open Sans,sans-serif;position:relative;top:-4px}.ptro-bar .ptro-input{height:32px;line-height:32px;font-size:16px;padding-left:2px;padding-right:0}.ptro-bar .ptro-input[type=number]{width:42px}.ptro-bar .ptro-named-btn p{margin:0}.ptro-bar{height:40px;bottom:0;position:absolute;width:100%;font-size:16px;line-height:normal}.ptro-bar .ptro-icon{font-size:20px}button.ptro-icon-right:first-of-type{margin-right:4px}@-webkit-keyframes ptro-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes ptro-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.ptro-spinning{-webkit-animation:ptro-spin .5s infinite steps(9);animation:ptro-spin .8s infinite steps(9);display:inline-block;text-rendering:auto;-webkit-font-smoothing:antialiased}", ""]);

// exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:iconfont;src:url(" + __webpack_require__(22) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(25) + ") format(\"woff\"),url(" + __webpack_require__(24) + ") format(\"truetype\"),url(" + __webpack_require__(23) + "#iconfont) format(\"svg\");font-weight:400;font-style:normal}.ptro-icon:before{font-family:iconfont!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ptro-icon-blur:before{content:\"\\F101\"}.ptro-icon-brush:before{content:\"\\F102\"}.ptro-icon-close:before{content:\"\\F103\"}.ptro-icon-crop:before{content:\"\\F104\"}.ptro-icon-ellipse:before{content:\"\\F105\"}.ptro-icon-line:before{content:\"\\F106\"}.ptro-icon-linked:before{content:\"\\F107\"}.ptro-icon-loading:before{content:\"\\F108\"}.ptro-icon-mirror:before{content:\"\\F109\"}.ptro-icon-open:before{content:\"\\F10A\"}.ptro-icon-painterro:before{content:\"\\F10B\"}.ptro-icon-paste_extend_down:before{content:\"\\F10C\"}.ptro-icon-paste_extend_right:before{content:\"\\F10D\"}.ptro-icon-paste_fit:before{content:\"\\F10E\"}.ptro-icon-paste_over:before{content:\"\\F10F\"}.ptro-icon-pipette:before{content:\"\\F110\"}.ptro-icon-pixelize:before{content:\"\\F111\"}.ptro-icon-rect:before{content:\"\\F112\"}.ptro-icon-resize:before{content:\"\\F113\"}.ptro-icon-rotate:before{content:\"\\F114\"}.ptro-icon-save:before{content:\"\\F115\"}.ptro-icon-select:before{content:\"\\F116\"}.ptro-icon-text:before{content:\"\\F117\"}.ptro-icon-unlinked:before{content:\"\\F118\"}", ""]);

// exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".ptro-wrapper{position:absolute;top:0;bottom:40px;left:0;right:0;text-align:center;z-index:10;font-family:Open Sans,sans-serif}.ptro-holder{position:fixed;box-shadow:3px 3px 15px #787878;left:35px;right:35px;top:35px;bottom:35px}.ptro-holder-wrapper{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.2)}.ptro-wrapper.ptro-v-aligned:before{content:\"\";display:inline-block;vertical-align:middle;height:100%}.ptro-icon-btn:disabled{color:gray}.ptro-wrapper canvas{vertical-align:middle;display:inline-block}.ptro-icon-btn{border:0;padding:4px 5px 5px;margin:4px 0 0 4px;height:32px;width:32px;cursor:pointer}.ptro-icon-btn i{line-height:23px}.ptro-named-btn{border:0;display:inline-block;height:30px;margin-left:4px;font-family:Open Sans,sans-serif;position:relative;top:-5px;font-size:14px;cursor:pointer}.color-diwget-btn:focus,.ptro-icon-btn:focus,.ptro-named-btn:focus,.ptro-selector-btn:focus{outline:none}.ptro-wrapper .select-handler{background-color:#fff;border:1px solid #000;width:6px;height:6px;position:absolute;z-index:10}.ptro-wrapper .ptro-crp-el{position:absolute}.ptro-wrapper .ptro-close-color-picker{height:24px;float:right;margin-top:5px}.ptro-wrapper .ptro-crp-rect{position:absolute;background-color:hsla(0,0%,88%,.5);border:1px dashed #000;cursor:move;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none;background-repeat:no-repeat;background-size:100% 100%}.ptro-wrapper .ptro-crp-tl{position:absolute;top:0;left:0;margin:-4px 0 0 -4px;cursor:se-resize}.ptro-wrapper .ptro-crp-bl{position:absolute;left:0;bottom:0;margin:0 0 -4px -4px;cursor:ne-resize}.ptro-wrapper .ptro-crp-br{position:absolute;right:0;bottom:0;margin:0 -4px -4px 0;cursor:se-resize}.ptro-wrapper .ptro-crp-tr{position:absolute;right:0;top:0;margin:-4px -4px 0 0;cursor:ne-resize}.ptro-wrapper .ptro-crp-l{position:absolute;top:50%;left:0;margin:-4px 0 0 -4px;cursor:e-resize}.ptro-wrapper .ptro-crp-t{position:absolute;top:0;left:50%;margin:-4px 0 0 -4px;cursor:s-resize}.ptro-wrapper .ptro-crp-r{position:absolute;top:50%;right:0;margin:-4px -4px 0 0;cursor:e-resize}.ptro-wrapper .ptro-crp-b{position:absolute;left:50%;bottom:0;margin:0 0 -4px -4px;cursor:s-resize}.ptro-bar .ptro-named-btn p,.ptro-bar .ptro-tool-ctl-name,.ptro-bar input,.ptro-wrapper div,.ptro-wrapper i,.ptro-wrapper span{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none}.ptro-info{font-family:Open Sans,sans-serif;font-size:10px;float:right;padding:22px 4px 4px 0}.ptro-wrapper .ptro-color-widget-wrapper,.ptro-wrapper .ptro-resize-widget-wrapper{position:absolute;background-color:rgba(0,0,0,.6);top:0;bottom:0;left:0;right:0}.ptro-wrapper .ptro-pallet canvas{cursor:crosshair}.ptro-wrapper .ptro-pallet{height:265px;margin-top:-115px;margin-left:-90px}.ptro-wrapper .ptro-pallet,.ptro-wrapper .ptro-resize-widget{width:200px;position:absolute;top:50%;left:50%;padding:10px;z-index:100;box-sizing:border-box}.ptro-wrapper .ptro-resize-widget{margin-top:-65px;margin-left:-100px}td.ptro-resize-table-left{text-align:right;padding-right:5px;float:none;font-size:14px}.ptro-wrapper .ptro-color-edit{margin-top:15px}.ptro-wrapper .ptro-color-edit input{float:left;height:24px;text-align:center;font-family:monospace;font-size:14px}.ptro-wrapper .ptro-color-edit input:focus{outline:none}.ptro-wrapper .ptro-color-edit input.ptro-color{width:70px}.ptro-wrapper .ptro-color-edit input.ptro-color-alpha{font-size:14px;width:55px;padding:0 0 0 2px;line-height:23px;height:23px}.ptro-wrapper .ptro-color-alpha-label,.ptro-wrapper .ptro-label{float:left;padding:0 2px 0 0;margin-left:5px;line-height:25px;font-family:Open Sans,sans-serif}.ptro-wrapper .ptro-pipette{float:right;height:24px;width:24px;margin:0}.ptro-wrapper .ptro-pipette i{line-height:16px}.ptro-wrapper .ptro-pipette:active{outline:none}.ptro-wrapper .ptro-color-widget-wrapper .ptro-canvas-alpha,.ptro-wrapper .ptro-color-widget-wrapper .ptro-canvas-light{margin-top:10px}span.ptro-color-alpha-regulator,span.ptro-color-light-regulator{display:block;margin-top:-5px;margin-left:5px;position:absolute;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid;cursor:crosshair}span.ptro-color-alpha-regulator{margin-top:0}.alpha-checkers{background-image:url(" + __webpack_require__(21) + ");display:block;width:100%;height:15px;background-size:10px 10px;margin-top:-20px}input.ptro-input:focus,select.ptro-input:focus{outline:none;box-shadow:none}input.ptro-input,select.ptro-input{vertical-align:initial;padding-top:0;padding-bottom:0;padding-right:0}.ptro-named-btn p{font-size:inherit;line-height:normal;margin:inherit}.ptro-wrapper .ptro-zoomer{border-top:1px solid #fff;border-left:1px solid #fff;position:absolute;z-index:2000;display:none}.ptro-text-tool-input{position:absolute;background-color:transparent;border:1px dashed;width:auto;display:block;min-width:5px;padding:0 1px;overflow-x:hidden;word-wrap:normal;overflow-y:hidden;box-sizing:content-box;line-height:normal}.ptro-text-tool-input:focus{outline:none}.ptro-bar-right{float:right;margin-right:4px}.ptro-link{float:left;margin-right:-12px;margin-top:-23px}.ptro-resize-link-wrapper{display:inline-block;height:20px}input.ptro-resize-heigth-input,input.ptro-resize-width-input{line-height:22px;padding:0 0 0 4px;height:22px}.ptro-selector-btn i{font-size:56px}.ptro-selector-btn{opacity:.8;border:0;width:100px;cursor:pointer}.ptro-selector-btn:not(:last-of-type){margin-right:10px}.ptro-selector-btn div{margin:5px 0}.ptro-paster-select .ptro-in div{font-family:Open Sans,sans-serif;font-size:14px}.ptro-selector-btn:hover{opacity:.6}.ptro-paster-select{display:inline-block;margin-left:auto;margin-right:auto;height:100%}.ptro-paster-select:before{content:\"\";display:inline-block;vertical-align:middle;height:100%}.ptro-paster-select .ptro-in{display:inline-block;background-color:rgba(0,0,0,.7);padding:10px}.ptro-paster-select-wrapper{position:absolute;top:0;left:0;right:0;bottom:0}.ptro-paste-label{color:#fff;margin-bottom:10px}.ptro-iframe{width:100%;height:100%;border:0}", ""]);

// exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// painterro-0.2.21.min.js